
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefae9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefae9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ge6e3", function(module, exports) {

$parcel$export(module.exports, "stringifyNum", () => $bd02c871d9c5ba8e$export$32c352b6867c6f6d);
$parcel$export(module.exports, "makeAbsolute", () => $bd02c871d9c5ba8e$export$79fc5653e15ea47f);
$parcel$export(module.exports, "reduceData", () => $bd02c871d9c5ba8e$export$93738ca0a9c2679b);
$parcel$export(module.exports, "crunchData", () => $bd02c871d9c5ba8e$export$17d14716b77fbbac);
$parcel$export(module.exports, "filterNonStrings", () => $bd02c871d9c5ba8e$export$313cb2a0ae7013dc);
$parcel$export(module.exports, "kFormatter", () => $bd02c871d9c5ba8e$export$467981646dda0d75);
$parcel$export(module.exports, "createShortDate", () => $bd02c871d9c5ba8e$export$d0673deee714e759);
$parcel$export(module.exports, "createLongDate", () => $bd02c871d9c5ba8e$export$ff455ac72342f5f6);
const $bd02c871d9c5ba8e$export$32c352b6867c6f6d = (number)=>number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const $bd02c871d9c5ba8e$export$79fc5653e15ea47f = (num)=>Math.abs(num);
const $bd02c871d9c5ba8e$export$93738ca0a9c2679b = (arr)=>arr.reduce((acc, num)=>acc + num, 0);
const $bd02c871d9c5ba8e$export$17d14716b77fbbac = function(arr) {
    if (!Array.isArray(arr) || arr.length < 1) return [];
    const singleNumber = $bd02c871d9c5ba8e$export$93738ca0a9c2679b(arr);
    return (singleNumber / arr.length).toFixed(2);
};
const $bd02c871d9c5ba8e$export$313cb2a0ae7013dc = (arr)=>{
    let filtered = arr.filter((item)=>typeof item === "string" || typeof item === "number").map((item)=>+item);
    if (filtered.length < 1) filtered = [
        0
    ];
    return filtered;
};
const $bd02c871d9c5ba8e$export$467981646dda0d75 = function(num, decimal = 999, unit = "k") {
    if (!num) return 0;
    return Math.abs(num) > decimal ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + unit : Math.sign(num) * Math.abs(num);
};
const $bd02c871d9c5ba8e$export$d0673deee714e759 = function(specifiedDate = "") {
    let joinedDate;
    if (specifiedDate) {
        const [month, date, year] = new Date(specifiedDate).toLocaleDateString("en-US").split("/");
        joinedDate = date + "/" + month + "/" + year.slice(-2);
    } else {
        const [month, date, year] = new Date().toLocaleDateString("en-US").split("/");
        joinedDate = date + "/" + month + "/" + year.slice(-2);
    }
    return joinedDate;
};
const $bd02c871d9c5ba8e$export$ff455ac72342f5f6 = function(shortDate) {
    let [year, month, day] = shortDate.split("/").reverse();
    // check if each data has the correct length
    if (year.length !== 2 || month.length > 2 && month.length < 1 || day.length > 2 || day.length < 1) return "ERROR";
    // coerce the string into numbers
    year = +("20" + year);
    month = +month;
    day = +day;
    // check if day, month or year failed the coercion due to incorrect format
    if (!year || !month || !day) return "ERROR";
    // get current year
    const currentYear = new Date().getFullYear();
    // run year, day and month range validation
    if ((year < 2010) ?? year > currentYear) return "ERROR";
    if (month < 0 || month > 12) return "ERROR";
    if (day < 1 || day > 31) return "ERROR";
    const fullDate = new Date(year, month - 1, day);
    return String(fullDate);
};

});

parcelRegister("fZ5A9", function(module, exports) {

$parcel$export(module.exports, "ENTRIES_PER_PAGE", () => $ba30e20475feac5a$export$d44a016ef85794c7);
$parcel$export(module.exports, "MONTHS_FORMAT", () => $ba30e20475feac5a$export$d87ac258782f4034);
$parcel$export(module.exports, "USER_USERNAME", () => $ba30e20475feac5a$export$4cd43f3a67e51a2b);
$parcel$export(module.exports, "USER_PASSWORD", () => $ba30e20475feac5a$export$5b906a9a1fc9de4);
const $ba30e20475feac5a$export$d44a016ef85794c7 = 8;
const $ba30e20475feac5a$export$d87ac258782f4034 = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec"
];
const $ba30e20475feac5a$export$4cd43f3a67e51a2b = "trader";
const $ba30e20475feac5a$export$5b906a9a1fc9de4 = "app";

});


var $ge6e3 = parcelRequire("ge6e3");

var $fZ5A9 = parcelRequire("fZ5A9");
var $f6d1a2e14413c93d$exports = {};
$f6d1a2e14413c93d$exports = JSON.parse('{"capital":7175,"initialCapital":7000,"newAccount":false,"overall":{"total":24,"proportions":[{"side":"long","total":13},{"side":"short","total":11}]},"streaks":{"wins":{"trades":[{"id":1618787408975,"ticker":"AMC","date":"17/2/21","returnCash":91.2},{"id":1618787468705,"ticker":"RIOT","date":"19/2/21","returnCash":106.8}]},"losses":{"trades":[{"id":1618787639837,"ticker":"VZ","date":"2/3/21","returnCash":-98.4},{"id":1618787689046,"ticker":"TWTR","date":"6/3/21","returnCash":-28.7}]},"current":{"trades":[{"id":1618788949757,"ticker":"WFC","date":"10/4/21","returnCash":112.8},{"id":1618790095230,"ticker":"RIOT","date":"14/4/21","returnCash":19.6},{"id":1618790222518,"ticker":"RIOT","date":"14/4/21","returnCash":42.7}]}},"worstTrades":[{"id":1618788220763,"dateLong":"Sun Mar 28 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"28/3/21","ticker":"TWTR","returnCash":-223.6},{"id":1618788301421,"dateLong":"Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"4/4/21","ticker":"OCGN","returnCash":-158.4},{"id":1618788047207,"dateLong":"Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"21/3/21","ticker":"SNAP","returnCash":-119},{"id":1618788815800,"dateLong":"Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"8/4/21","ticker":"AAL","returnCash":-105},{"id":1618787639837,"dateLong":"Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"2/3/21","ticker":"VZ","returnCash":-98.4},{"id":1618787878176,"dateLong":"Sun Mar 14 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"14/3/21","ticker":"AAL","returnCash":-79},{"id":1618787516761,"dateLong":"Sun Feb 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"21/2/21","ticker":"SNAP","returnCash":-30},{"id":1618787689046,"dateLong":"Sat Mar 06 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"6/3/21","ticker":"TWTR","returnCash":-28.7},{"id":1618788389926,"dateLong":"Tue Apr 06 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"6/4/21","ticker":"WFC","returnCash":-21.5}],"bestTrades":[{"id":1618788552011,"dateLong":"Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"8/4/21","ticker":"BMBL","returnCash":123.6},{"id":1618788154757,"dateLong":"Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"21/3/21","ticker":"NIO","returnCash":116},{"id":1618788949757,"dateLong":"Sat Apr 10 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"10/4/21","ticker":"WFC","returnCash":112.8},{"id":1618787468705,"dateLong":"Fri Feb 19 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"19/2/21","ticker":"RIOT","returnCash":106.8},{"id":1618787566463,"dateLong":"Thu Feb 25 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"25/2/21","ticker":"NIO","returnCash":101},{"id":1618787408975,"dateLong":"Wed Feb 17 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"17/2/21","ticker":"AMC","returnCash":91.2},{"id":1618788260204,"dateLong":"Sat Apr 03 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"3/4/21","ticker":"AMC","returnCash":91},{"id":1618788358393,"dateLong":"Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"4/4/21","ticker":"BMBL","returnCash":66.5},{"id":1618787603816,"dateLong":"Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"2/3/21","ticker":"BMBL","returnCash":63.7},{"id":1618790222518,"dateLong":"Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"14/4/21","ticker":"RIOT","returnCash":42.7},{"id":1618787828559,"dateLong":"Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"11/3/21","ticker":"NIO","returnCash":41},{"id":1618787983228,"dateLong":"Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"18/3/21","ticker":"AMC","returnCash":31.2},{"id":1618790095230,"dateLong":"Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"14/4/21","ticker":"RIOT","returnCash":19.6},{"id":1618787937979,"dateLong":"Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"18/3/21","ticker":"WFC","returnCash":16},{"id":1618787722775,"dateLong":"Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"11/3/21","ticker":"OCGN","returnCash":15}],"tickers":{"AMC":{"ticker":"AMC","avgReturn":71.13,"trades":[{"id":1618787408975,"shares":80,"returnCash":91.2,"returnPercent":1.3},{"id":1618787983228,"shares":60,"returnCash":31.2,"returnPercent":0.43},{"id":1618788260204,"shares":100,"returnCash":91,"returnPercent":1.3}]},"RIOT":{"ticker":"RIOT","avgReturn":56.37,"trades":[{"id":1618787468705,"shares":60,"returnCash":106.8,"returnPercent":1.51},{"id":1618790095230,"shares":70,"returnCash":19.6,"returnPercent":0.28},{"id":1618790222518,"shares":70,"returnCash":42.7,"returnPercent":0.6}]},"SNAP":{"ticker":"SNAP","avgReturn":-74.5,"trades":[{"id":1618787516761,"shares":60,"returnCash":-30,"returnPercent":-0.42},{"id":1618788047207,"shares":70,"returnCash":-119,"returnPercent":-1.65}]},"NIO":{"ticker":"NIO","avgReturn":86,"trades":[{"id":1618787566463,"shares":100,"returnCash":101,"returnPercent":1.41},{"id":1618787828559,"shares":100,"returnCash":41,"returnPercent":0.57},{"id":1618788154757,"shares":80,"returnCash":116,"returnPercent":1.63}]},"BMBL":{"ticker":"BMBL","avgReturn":84.6,"trades":[{"id":1618787603816,"shares":70,"returnCash":63.7,"returnPercent":0.88},{"id":1618788358393,"shares":70,"returnCash":66.5,"returnPercent":0.96},{"id":1618788552011,"shares":120,"returnCash":123.6,"returnPercent":1.77}]},"VZ":{"ticker":"VZ","avgReturn":-98.4,"trades":[{"id":1618787639837,"shares":80,"returnCash":-98.4,"returnPercent":-1.34}]},"TWTR":{"ticker":"TWTR","avgReturn":-126.15,"trades":[{"id":1618787689046,"shares":70,"returnCash":-28.7,"returnPercent":-0.4},{"id":1618788220763,"shares":130,"returnCash":-223.6,"returnPercent":-3.09}]},"OCGN":{"ticker":"OCGN","avgReturn":-71.7,"trades":[{"id":1618787722775,"shares":50,"returnCash":15,"returnPercent":0.21},{"id":1618788301421,"shares":90,"returnCash":-158.4,"returnPercent":-2.23}]},"AAL":{"ticker":"AAL","avgReturn":-92,"trades":[{"id":1618787878176,"shares":100,"returnCash":-79,"returnPercent":-1.09},{"id":1618788815800,"shares":100,"returnCash":-105,"returnPercent":-1.48}]},"WFC":{"ticker":"WFC","avgReturn":35.77,"trades":[{"id":1618787937979,"shares":100,"returnCash":16,"returnPercent":0.22},{"id":1618788389926,"shares":50,"returnCash":-21.5,"returnPercent":-0.31},{"id":1618788949757,"shares":120,"returnCash":112.8,"returnPercent":1.61}]}},"calendarData":{"feb21":[{"dateLong":"Wed Feb 17 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"17/2/21","trades":[{"id":1618787408975,"side":"long","returnCash":91.2,"returnPercent":1.3,"total":7091.2}]},{"dateLong":"Fri Feb 19 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"19/2/21","trades":[{"id":1618787468705,"side":"short","returnCash":106.8,"returnPercent":1.51,"total":7198}]},{"dateLong":"Sun Feb 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"21/2/21","trades":[{"id":1618787516761,"side":"short","returnCash":-30,"returnPercent":-0.42,"total":7168}]},{"dateLong":"Thu Feb 25 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"25/2/21","trades":[{"id":1618787566463,"side":"long","returnCash":101,"returnPercent":1.41,"total":7269}]}],"mar21":[{"dateLong":"Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"2/3/21","trades":[{"id":1618787603816,"side":"long","returnCash":63.7,"returnPercent":0.88,"total":7332.7},{"id":1618787639837,"side":"long","returnCash":-98.4,"returnPercent":-1.34,"total":7234.3}]},{"dateLong":"Sat Mar 06 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"6/3/21","trades":[{"id":1618787689046,"side":"short","returnCash":-28.7,"returnPercent":-0.4,"total":7205.6}]},{"dateLong":"Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"11/3/21","trades":[{"id":1618787722775,"side":"long","returnCash":15,"returnPercent":0.21,"total":7220.6},{"id":1618787828559,"side":"short","returnCash":41,"returnPercent":0.57,"total":7261.6}]},{"dateLong":"Sun Mar 14 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"14/3/21","trades":[{"id":1618787878176,"side":"long","returnCash":-79,"returnPercent":-1.09,"total":7182.6}]},{"dateLong":"Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"18/3/21","trades":[{"id":1618787937979,"side":"long","returnCash":16,"returnPercent":0.22,"total":7198.6},{"id":1618787983228,"side":"short","returnCash":31.2,"returnPercent":0.43,"total":7229.8}]},{"dateLong":"Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"21/3/21","trades":[{"id":1618788047207,"side":"long","returnCash":-119,"returnPercent":-1.65,"total":7110.8},{"id":1618788154757,"side":"long","returnCash":116,"returnPercent":1.63,"total":7226.8}]},{"dateLong":"Sun Mar 28 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"28/3/21","trades":[{"id":1618788220763,"side":"short","returnCash":-223.6,"returnPercent":-3.09,"total":7003.2}]}],"apr21":[{"dateLong":"Sat Apr 03 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"3/4/21","trades":[{"id":1618788260204,"side":"long","returnCash":91,"returnPercent":1.3,"total":7094.2}]},{"dateLong":"Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"4/4/21","trades":[{"id":1618788301421,"side":"short","returnCash":-158.4,"returnPercent":-2.23,"total":6935.8},{"id":1618788358393,"side":"short","returnCash":66.5,"returnPercent":0.96,"total":7002.3}]},{"dateLong":"Tue Apr 06 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"6/4/21","trades":[{"id":1618788389926,"side":"long","returnCash":-21.5,"returnPercent":-0.31,"total":6980.8}]},{"dateLong":"Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"8/4/21","trades":[{"id":1618788552011,"side":"short","returnCash":123.6,"returnPercent":1.77,"total":7104.400000000001},{"id":1618788815800,"side":"long","returnCash":-105,"returnPercent":-1.48,"total":6999.400000000001}]},{"dateLong":"Sat Apr 10 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"10/4/21","trades":[{"id":1618788949757,"side":"short","returnCash":112.8,"returnPercent":1.61,"total":7112.200000000001}]},{"dateLong":"Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"14/4/21","trades":[{"id":1618790095230,"side":"long","returnCash":19.6,"returnPercent":0.28,"total":7131.800000000001},{"id":1618790222518,"side":"short","returnCash":42.7,"returnPercent":0.6,"total":7174.500000000001}]}]},"journal":[{"id":1618787408975,"dateLong":"Wed Feb 17 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"17/2/21","ticker":"AMC","side":"long","tradeEntries":[[9.45,40],[9.62,40]],"tradeExits":[[10.68,80]],"sharesAmount":80,"avgEntry":9.54,"avgExit":10.68,"returnCash":91.2,"returnPercent":1.3,"body":"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae sapien pellentesque habitant morbi. Aliquam id diam maecenas ultricies mi eget. Montes nascetur ridiculus mus mauris vitae ultricies. Eget felis eget nunc lobortis. Sed lectus vestibulum mattis ullamcorper velit sed ullamcorper morbi. Interdum velit laoreet id donec. Ac feugiat sed lectus vestibulum mattis ullamcorper velit sed ullamcorper. Lacus sed turpis tincidunt id aliquet risus feugiat. Egestas integer eget aliquet nibh praesent tristique magna sit amet.","previousTicker":"AMC","previousDateShort":"17/2/21","previousDateLong":"Wed Feb 17 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7091.2},{"id":1618787468705,"dateLong":"Fri Feb 19 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"19/2/21","ticker":"RIOT","side":"short","tradeEntries":[[49.94,60]],"tradeExits":[[48.16,60]],"sharesAmount":60,"avgEntry":49.94,"avgExit":48.16,"returnCash":106.8,"returnPercent":1.51,"body":"Sed libero enim sed faucibus. Amet consectetur adipiscing elit pellentesque habitant morbi tristique senectus. Vel fringilla est ullamcorper eget nulla facilisi. Quam lacus suspendisse faucibus interdum posuere lorem ipsum. Porttitor leo a diam sollicitudin. Morbi non arcu risus quis varius. Nibh tellus molestie nunc non blandit massa. Vel turpis nunc eget lorem dolor sed viverra ipsum nunc. Tellus id interdum velit laoreet id donec. Ipsum consequat nisl vel pretium lectus quam. Ut tristique et egestas quis ipsum. ","previousTicker":"RIOT","previousDateShort":"19/2/21","previousDateLong":"Fri Feb 19 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7198},{"id":1618787516761,"dateLong":"Sun Feb 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"21/2/21","ticker":"SNAP","side":"short","tradeEntries":[[63.17,40],[63.33,20]],"tradeExits":[[63.72,60]],"sharesAmount":60,"avgEntry":63.22,"avgExit":63.72,"returnCash":-30,"returnPercent":-0.42,"body":"","previousTicker":"SNAP","previousDateShort":"21/2/21","previousDateLong":"Sun Feb 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7168},{"id":1618787566463,"dateLong":"Thu Feb 25 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"25/2/21","ticker":"NIO","side":"long","tradeEntries":[[38.11,50],[38.22,50]],"tradeExits":[[39.17,100]],"sharesAmount":100,"avgEntry":38.16,"avgExit":39.17,"returnCash":101,"returnPercent":1.41,"body":"At auctor urna nunc id cursus. Maecenas pharetra convallis posuere morbi leo urna molestie at elementum. Lacinia at quis risus sed vulputate odio ut. Posuere lorem ipsum dolor sit amet consectetur adipiscing. Sed elementum tempus egestas sed sed risus pretium quam. Sit amet massa vitae tortor condimentum lacinia quis vel. Eget felis eget nunc lobortis. Netus et malesuada fames ac turpis egestas sed tempus urna. Diam quam nulla porttitor massa id neque. Convallis posuere morbi leo urna. Mauris cursus mattis molestie a iaculis. Ultricies lacus sed turpis tincidunt id aliquet risus feugiat in. Scelerisque mauris pellentesque pulvinar pellentesque. ","previousTicker":"NIO","previousDateShort":"25/2/21","previousDateLong":"Thu Feb 25 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7269},{"id":1618787603816,"dateLong":"Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"2/3/21","ticker":"BMBL","side":"long","tradeEntries":[[60.16,70]],"tradeExits":[[61.07,70]],"sharesAmount":70,"avgEntry":60.16,"avgExit":61.07,"returnCash":63.7,"returnPercent":0.88,"body":"","previousTicker":"BMBL","previousDateShort":"2/3/21","previousDateLong":"Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7332.7},{"id":1618787639837,"dateLong":"Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"2/3/21","ticker":"VZ","side":"long","tradeEntries":[[57.47,80]],"tradeExits":[[56.24,80]],"sharesAmount":80,"avgEntry":57.47,"avgExit":56.24,"returnCash":-98.4,"returnPercent":-1.34,"body":"Morbi blandit cursus risus at ultrices mi tempus. Amet cursus sit amet dictum sit amet. Viverra accumsan in nisl nisi. Mauris pellentesque pulvinar pellentesque habitant morbi. Eleifend quam adipiscing vitae proin sagittis nisl. Risus commodo viverra maecenas accumsan lacus vel facilisis. Porta lorem mollis aliquam ut porttitor leo. Odio morbi quis commodo odio aenean. ","previousTicker":"VZ","previousDateShort":"2/3/21","previousDateLong":"Tue Mar 02 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7234.3},{"id":1618787689046,"dateLong":"Sat Mar 06 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"6/3/21","ticker":"TWTR","side":"short","tradeEntries":[[71.96,70]],"tradeExits":[[72.37,70]],"sharesAmount":70,"avgEntry":71.96,"avgExit":72.37,"returnCash":-28.7,"returnPercent":-0.4,"body":"Volutpat odio facilisis mauris sit amet massa. Dui sapien eget mi proin sed libero enim sed. Morbi tempus iaculis urna id volutpat lacus laoreet. Tempus urna et pharetra pharetra. Et tortor at risus viverra. Quam viverra orci sagittis eu volutpat odio. Enim diam vulputate ut pharetra sit. Nibh sit amet commodo nulla facilisi nullam vehicula. Vivamus at augue eget arcu dictum varius. Faucibus a pellentesque sit amet porttitor. Justo nec ultrices dui sapien eget mi proin sed libero. Eleifend donec pretium vulputate sapien nec. Cursus mattis molestie a iaculis at erat pellentesque adipiscing. ","previousTicker":"TWTR","previousDateShort":"6/3/21","previousDateLong":"Sat Mar 06 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7205.6},{"id":1618787722775,"dateLong":"Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"11/3/21","ticker":"OCGN","side":"long","tradeEntries":[[6.68,50]],"tradeExits":[[6.98,50]],"sharesAmount":50,"avgEntry":6.68,"avgExit":6.98,"returnCash":15,"returnPercent":0.21,"body":"","previousTicker":"OCGN","previousDateShort":"11/3/21","previousDateLong":"Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7220.6},{"id":1618787828559,"dateLong":"Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"11/3/21","ticker":"NIO","side":"short","tradeEntries":[[34.43,100]],"tradeExits":[[34.02,100]],"sharesAmount":100,"avgEntry":34.43,"avgExit":34.02,"returnCash":41,"returnPercent":0.57,"body":"Sed blandit libero volutpat sed. Nunc congue nisi vitae suscipit tellus. Lectus sit amet est placerat in. Commodo sed egestas egestas fringilla phasellus faucibus scelerisque eleifend. Purus gravida quis blandit turpis cursus in hac. Facilisis magna etiam tempor orci eu. Dignissim suspendisse in est ante in nibh mauris cursus. Aliquet nibh praesent tristique magna sit amet purus gravida. Non quam lacus suspendisse faucibus interdum posuere lorem ipsum dolor. Urna cursus eget nunc scelerisque viverra mauris. Accumsan lacus vel facilisis volutpat est velit egestas dui. Lobortis scelerisque fermentum dui faucibus. Et netus et malesuada fames. Dui id ornare arcu odio ut sem.","previousTicker":"NIO","previousDateShort":"11/3/21","previousDateLong":"Thu Mar 11 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7261.6},{"id":1618787878176,"dateLong":"Sun Mar 14 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"14/3/21","ticker":"AAL","side":"long","tradeEntries":[[22.03,60],[21.98,40]],"tradeExits":[[21.22,100]],"sharesAmount":100,"avgEntry":22.01,"avgExit":21.22,"returnCash":-79,"returnPercent":-1.09,"body":"Quisque egestas diam in arcu cursus euismod quis viverra nibh. Vestibulum morbi blandit cursus risus at ultrices mi tempus imperdiet. Urna et pharetra pharetra massa. Commodo odio aenean sed adipiscing diam donec adipiscing tristique risus. Vulputate sapien nec sagittis aliquam malesuada bibendum arcu vitae. Auctor eu augue ut lectus arcu bibendum. Morbi tempus iaculis urna id. Metus aliquam eleifend mi in nulla posuere sollicitudin aliquam. ","previousTicker":"AAL","previousDateShort":"14/3/21","previousDateLong":"Sun Mar 14 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7182.6},{"id":1618787937979,"dateLong":"Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"18/3/21","ticker":"WFC","side":"long","tradeEntries":[[42.24,50],[42.42,50]],"tradeExits":[[42.49,100]],"sharesAmount":100,"avgEntry":42.33,"avgExit":42.49,"returnCash":16,"returnPercent":0.22,"body":"Vitae proin sagittis nisl rhoncus mattis rhoncus urna neque. Amet dictum sit amet justo donec. Sit amet volutpat consequat mauris. Integer malesuada nunc vel risus commodo viverra maecenas accumsan lacus. Mauris commodo quis imperdiet massa. Euismod elementum nisi quis eleifend quam adipiscing vitae proin. Orci nulla pellentesque dignissim enim sit amet venenatis.","previousTicker":"WFC","previousDateShort":"18/3/21","previousDateLong":"Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7198.6},{"id":1618787983228,"dateLong":"Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"18/3/21","ticker":"AMC","side":"short","tradeEntries":[[10.76,60]],"tradeExits":[[10.24,60]],"sharesAmount":60,"avgEntry":10.76,"avgExit":10.24,"returnCash":31.2,"returnPercent":0.43,"body":"Dui id ornare arcu odio ut sem nulla. Nec ultrices dui sapien eget mi proin sed. Etiam sit amet nisl purus in. Nec tincidunt praesent semper feugiat nibh sed pulvinar. Cursus in hac habitasse platea dictumst quisque sagittis purus. Id venenatis a condimentum vitae sapien pellentesque habitant morbi. Facilisi etiam dignissim diam quis enim lobortis. Orci phasellus egestas tellus rutrum. Malesuada pellentesque elit eget gravida cum. Velit sed ullamcorper morbi tincidunt.","previousTicker":"AMC","previousDateShort":"18/3/21","previousDateLong":"Thu Mar 18 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7229.8},{"id":1618788047207,"dateLong":"Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"21/3/21","ticker":"SNAP","side":"long","tradeEntries":[[64.66,40],[64.56,30]],"tradeExits":[[62.92,70]],"sharesAmount":70,"avgEntry":64.62,"avgExit":62.92,"returnCash":-119,"returnPercent":-1.65,"body":"Egestas quis ipsum suspendisse ultrices gravida dictum. Lorem sed risus ultricies tristique nulla aliquet enim. Montes nascetur ridiculus mus mauris vitae ultricies leo. Nisl condimentum id venenatis a condimentum vitae. Eu lobortis elementum nibh tellus molestie nunc non blandit. Praesent semper feugiat nibh sed pulvinar. Eget nulla facilisi etiam dignissim diam quis enim. Purus ut faucibus pulvinar elementum integer enim. Leo urna molestie at elementum eu facilisis sed. Sit amet est placerat in egestas erat imperdiet sed euismod. Varius vel pharetra vel turpis nunc eget lorem. Laoreet suspendisse interdum consectetur libero id faucibus nisl tincidunt.","previousTicker":"SNAP","previousDateShort":"21/3/21","previousDateLong":"Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7110.8},{"id":1618788154757,"dateLong":"Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"21/3/21","ticker":"NIO","side":"long","tradeEntries":[[44.43,50],[44.67,30]],"tradeExits":[[45.97,80]],"sharesAmount":80,"avgEntry":44.52,"avgExit":45.97,"returnCash":116,"returnPercent":1.63,"body":"Nibh praesent tristique magna sit amet purus gravida quis blandit. Mattis pellentesque id nibh tortor id aliquet lectus proin. Proin nibh nisl condimentum id venenatis a condimentum. Hac habitasse platea dictumst vestibulum. Arcu non odio euismod lacinia at quis risus sed vulputate. Sed arcu non odio euismod lacinia at. Non pulvinar neque laoreet suspendisse interdum consectetur libero id. Cursus euismod quis viverra nibh cras pulvinar. Vulputate sapien nec sagittis aliquam malesuada bibendum arcu vitae elementum. Vivamus arcu felis bibendum ut. Et sollicitudin ac orci phasellus egestas. Sit amet justo donec enim. Sed blandit libero volutpat sed cras ornare. Ipsum suspendisse ultrices gravida dictum. Posuere sollicitudin aliquam ultrices sagittis. ","previousTicker":"NIO","previousDateShort":"21/3/21","previousDateLong":"Sun Mar 21 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7226.8},{"id":1618788220763,"dateLong":"Sun Mar 28 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","dateShort":"28/3/21","ticker":"TWTR","side":"short","tradeEntries":[[78.45,100],[78.32,30]],"tradeExits":[[80.14,130]],"sharesAmount":130,"avgEntry":78.42,"avgExit":80.14,"returnCash":-223.6,"returnPercent":-3.09,"body":"","previousTicker":"TWTR","previousDateShort":"28/3/21","previousDateLong":"Sun Mar 28 2021 00:00:00 GMT+0000 (Greenwich Mean Time)","total":7003.2},{"id":1618788260204,"dateLong":"Sat Apr 03 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"3/4/21","ticker":"AMC","side":"long","tradeEntries":[[12.47,50],[12.61,50]],"tradeExits":[[13.45,100]],"sharesAmount":100,"avgEntry":12.54,"avgExit":13.45,"returnCash":91,"returnPercent":1.3,"body":"Sed felis eget velit aliquet sagittis. Arcu cursus vitae congue mauris rhoncus aenean vel. Imperdiet proin fermentum leo vel orci porta. Sagittis purus sit amet volutpat consequat mauris nunc congue. Aliquam sem fringilla ut morbi tincidunt. Sagittis vitae et leo duis ut diam quam nulla porttitor. Nunc non blandit massa enim. At consectetur lorem donec massa sapien faucibus. Lorem ipsum dolor sit amet consectetur. Vulputate enim nulla aliquet porttitor lacus luctus accumsan. Nec feugiat in fermentum posuere urna nec tincidunt. Neque vitae tempus quam pellentesque.","previousTicker":"AMC","previousDateShort":"3/4/21","previousDateLong":"Sat Apr 03 2021 00:00:00 GMT+0100 (British Summer Time)","total":7094.2},{"id":1618788301421,"dateLong":"Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"4/4/21","ticker":"OCGN","side":"short","tradeEntries":[[7.26,90]],"tradeExits":[[9.02,90]],"sharesAmount":90,"avgEntry":7.26,"avgExit":9.02,"returnCash":-158.4,"returnPercent":-2.23,"body":"Placerat in egestas erat imperdiet sed euismod. Pretium quam vulputate dignissim suspendisse in est ante in. Elementum integer enim neque volutpat ac tincidunt. Mollis aliquam ut porttitor leo a diam. Ultricies mi quis hendrerit dolor magna eget est. Pharetra sit amet aliquam id. Ut etiam sit amet nisl. Facilisis magna etiam tempor orci eu. Lorem dolor sed viverra ipsum nunc aliquet. Aliquet risus feugiat in ante metus dictum at tempor. Tortor consequat id porta nibh venenatis cras sed. At tellus at urna condimentum mattis pellentesque.","previousTicker":"OCGN","previousDateShort":"4/4/21","previousDateLong":"Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)","total":6935.8},{"id":1618788358393,"dateLong":"Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"4/4/21","ticker":"BMBL","side":"short","tradeEntries":[[59.89,70]],"tradeExits":[[59.02,30],[58.88,40]],"sharesAmount":70,"avgEntry":59.89,"avgExit":58.94,"returnCash":66.5,"returnPercent":0.96,"body":"Varius duis at consectetur lorem donec. Consequat ac felis donec et. Gravida quis blandit turpis cursus in hac. Tellus in metus vulputate eu scelerisque felis imperdiet. Accumsan lacus vel facilisis volutpat est velit egestas. Amet nulla facilisi morbi tempus iaculis. Blandit massa enim nec dui nunc mattis enim ut tellus. Vel risus commodo viverra maecenas accumsan lacus. Parturient montes nascetur ridiculus mus mauris vitae ultricies leo integer. Massa enim nec dui nunc.","previousTicker":"BMBL","previousDateShort":"4/4/21","previousDateLong":"Sun Apr 04 2021 00:00:00 GMT+0100 (British Summer Time)","total":7002.3},{"id":1618788389926,"dateLong":"Tue Apr 06 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"6/4/21","ticker":"WFC","side":"long","tradeEntries":[[49.54,50]],"tradeExits":[[49.11,50]],"sharesAmount":50,"avgEntry":49.54,"avgExit":49.11,"returnCash":-21.5,"returnPercent":-0.31,"body":"","previousTicker":"WFC","previousDateShort":"6/4/21","previousDateLong":"Tue Apr 06 2021 00:00:00 GMT+0100 (British Summer Time)","total":6980.8},{"id":1618788552011,"dateLong":"Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"8/4/21","ticker":"BMBL","side":"short","tradeEntries":[[63.37,70],[63.25,50]],"tradeExits":[[62.44,60],[62.14,60]],"sharesAmount":120,"avgEntry":63.32,"avgExit":62.29,"returnCash":123.6,"returnPercent":1.77,"body":"Sodales ut eu sem integer vitae justo eget. Commodo viverra maecenas accumsan lacus vel facilisis volutpat est. Varius quam quisque id diam vel quam elementum pulvinar. Sed ullamcorper morbi tincidunt ornare massa eget. Tincidunt arcu non sodales neque sodales ut etiam sit amet. Netus et malesuada fames ac turpis. Velit aliquet sagittis id consectetur purus. Vestibulum lectus mauris ultrices eros in cursus. Sem integer vitae justo eget magna. Scelerisque mauris pellentesque pulvinar pellentesque. Id consectetur purus ut faucibus pulvinar elementum integer. Odio euismod lacinia at quis risus sed vulputate. Nulla facilisi nullam vehicula ipsum a arcu cursus vitae congue. Sed egestas egestas fringilla phasellus faucibus scelerisque eleifend donec pretium. In nisl nisi scelerisque eu. Vitae sapien pellentesque habitant morbi tristique senectus. Facilisi etiam dignissim diam quis.","previousTicker":"BMBL","previousDateShort":"8/4/21","previousDateLong":"Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)","total":7104.400000000001},{"id":1618788815800,"dateLong":"Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"8/4/21","ticker":"AAL","side":"long","tradeEntries":[[23.57,100]],"tradeExits":[[22.52,100]],"sharesAmount":100,"avgEntry":23.57,"avgExit":22.52,"returnCash":-105,"returnPercent":-1.48,"body":"","previousTicker":"AAL","previousDateShort":"8/4/21","previousDateLong":"Thu Apr 08 2021 00:00:00 GMT+0100 (British Summer Time)","total":6999.400000000001},{"id":1618788949757,"dateLong":"Sat Apr 10 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"10/4/21","ticker":"WFC","side":"short","tradeEntries":[[42.27,70],[42.11,50]],"tradeExits":[[41.44,40],[41.31,40],[41.02,40]],"sharesAmount":120,"avgEntry":42.2,"avgExit":41.26,"returnCash":112.8,"returnPercent":1.61,"body":"Enim tortor at auctor urna nunc. Pellentesque pulvinar pellentesque habitant morbi tristique. Leo vel orci porta non pulvinar. Porta nibh venenatis cras sed. Sapien pellentesque habitant morbi tristique senectus. At ultrices mi tempus imperdiet. Pretium vulputate sapien nec sagittis aliquam malesuada bibendum arcu vitae. Integer eget aliquet nibh praesent tristique magna sit amet purus. Ullamcorper sit amet risus nullam eget felis eget nunc lobortis. Enim sit amet venenatis urna cursus eget. Sed nisi lacus sed viverra tellus. Morbi tempus iaculis urna id volutpat. Ipsum dolor sit amet consectetur adipiscing elit ut aliquam purus. Sapien eget mi proin sed libero enim sed faucibus turpis. Neque egestas congue quisque egestas diam in arcu cursus.","previousTicker":"WFC","previousDateShort":"10/4/21","previousDateLong":"Sat Apr 10 2021 00:00:00 GMT+0100 (British Summer Time)","total":7112.200000000001},{"id":1618790095230,"dateLong":"Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"14/4/21","ticker":"RIOT","side":"long","tradeEntries":[[49.7,70]],"tradeExits":[[49.98,70]],"sharesAmount":70,"avgEntry":49.7,"avgExit":49.98,"returnCash":19.6,"returnPercent":0.28,"body":"","previousTicker":"RIOT","previousDateShort":"14/4/21","previousDateLong":"Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)","total":7131.800000000001},{"id":1618790222518,"dateLong":"Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)","dateShort":"14/4/21","ticker":"RIOT","side":"short","tradeEntries":[[50.69,70]],"tradeExits":[[50.13,30],[50.04,40]],"sharesAmount":70,"avgEntry":50.69,"avgExit":50.08,"returnCash":42.7,"returnPercent":0.6,"body":"","previousTicker":"RIOT","previousDateShort":"14/4/21","previousDateLong":"Wed Apr 14 2021 00:00:00 GMT+0100 (British Summer Time)","total":7174.500000000001}],"dummyJournal":[{"id":"","dateLong":"","dateShort":"","ticker":"","side":"","tradeEntries":[["",""]],"tradeExits":[["",""]],"sharesAmount":"","avgEntry":"","avgExit":"","returnCash":"","returnPercent":"","total":"","previousTicker":"","previousDateShort":"","previousDateLong":"","body":""}]}');


let $b33589c348b8bea3$var$user;
const $b33589c348b8bea3$var$startingUserObject = {
    capital: 0,
    initialCapital: 0,
    newAccount: true,
    overall: {
        total: 0,
        proportions: [
            {
                side: "long",
                total: 0
            },
            {
                side: "short",
                total: 0
            }
        ]
    },
    streaks: {
        wins: {
            trades: []
        },
        losses: {
            trades: []
        },
        current: {
            trades: []
        }
    },
    worstTrades: [],
    bestTrades: [],
    tickers: {},
    calendarData: {},
    journal: [],
    dummyJournal: [
        {
            id: "",
            dateLong: "",
            dateShort: "",
            ticker: "",
            side: "",
            tradeEntries: [
                [
                    "",
                    ""
                ]
            ],
            tradeExits: [
                [
                    "",
                    ""
                ]
            ],
            sharesAmount: "",
            avgEntry: "",
            avgExit: "",
            returnCash: "",
            returnPercent: "",
            total: "",
            previousTicker: "",
            previousDateShort: "",
            previousDateLong: "",
            body: ""
        }
    ]
};
const $b33589c348b8bea3$export$3197e788f26697e3 = function() {
    $b33589c348b8bea3$var$user = $b33589c348b8bea3$var$startingUserObject;
    if (0, (/*@__PURE__*/$parcel$interopDefault($f6d1a2e14413c93d$exports))) $b33589c348b8bea3$var$user = (0, (/*@__PURE__*/$parcel$interopDefault($f6d1a2e14413c93d$exports)));
    console.log($b33589c348b8bea3$var$user);
};
const $b33589c348b8bea3$export$a50b7e3211510c43 = function() {
    $b33589c348b8bea3$var$user = $b33589c348b8bea3$var$startingUserObject;
    console.log($b33589c348b8bea3$var$user);
};
const $b33589c348b8bea3$export$b126a3dab554319 = function() {
    if ($b33589c348b8bea3$var$user.journal.length < 1) return "empty";
    if ($b33589c348b8bea3$var$user.journal.length > 0) return "full";
};
const $b33589c348b8bea3$var$sortJournal = (data)=>data.sort((a, b)=>new Date(a.dateLong) - new Date(b.dateLong));
const $b33589c348b8bea3$var$addToOverall = function(newEntry, newEntryIndex, previousSide) {
    if (newEntryIndex === -1) $b33589c348b8bea3$var$user.overall.total++;
    if (newEntryIndex !== -1 && previousSide === "short") $b33589c348b8bea3$var$user.overall.proportions[1].total--;
    if (newEntryIndex !== -1 && previousSide === "long") $b33589c348b8bea3$var$user.overall.proportions[0].total--;
    if (previousSide === "short" && newEntry.side === "long") {
        $b33589c348b8bea3$var$user.overall.proportions[0].total++;
        $b33589c348b8bea3$var$user.overall.proportions[1].total--;
        return;
    }
    if (previousSide === "long" && newEntry.side === "short") {
        $b33589c348b8bea3$var$user.overall.proportions[0].total--;
        $b33589c348b8bea3$var$user.overall.proportions[1].total++;
        return;
    }
    if (newEntry.side === "long") $b33589c348b8bea3$var$user.overall.proportions[0].total++;
    if (newEntry.side === "short") $b33589c348b8bea3$var$user.overall.proportions[1].total++;
};
const $b33589c348b8bea3$var$compareToStreaks = function(newEntry) {
    const streakObj = {
        id: newEntry.id,
        ticker: newEntry.ticker,
        date: newEntry.dateShort,
        returnCash: newEntry.returnCash
    };
    // losing streak - checks whether the entry exists in the losing streak
    const indexInLosses = $b33589c348b8bea3$var$user.streaks.losses.trades ? $b33589c348b8bea3$var$user.streaks.losses.trades.map((loss)=>loss.id).indexOf(newEntry.id) : -1;
    // if the index exists and the new entry's cash return is smaller than zero, overwrite the index
    if (indexInLosses !== -1 && newEntry.returnCash < 0) $b33589c348b8bea3$var$user.streaks.losses.trades[indexInLosses] = streakObj;
    // if the index exists and the new entry's cash return is bigger than zero, remove the entry from losing streak
    if (indexInLosses !== -1 && newEntry.returnCash > -1) $b33589c348b8bea3$var$user.streaks.losses.trades.splice(indexInLosses, 1);
    // winning streak - checks whether the entry exists in the winning streak
    const indexInWins = $b33589c348b8bea3$var$user.streaks.wins.trades ? $b33589c348b8bea3$var$user.streaks.wins.trades.map((win)=>win.id).indexOf(newEntry.id) : -1;
    // if the index exists and the new entry's cash return is bigger than zero, overwrite the index
    if (indexInWins !== -1 && newEntry.returnCash > -1) $b33589c348b8bea3$var$user.streaks.wins.trades[indexInWins] = streakObj;
    // if the index exists and the new entry's cash return is smaller than zero, remove the entry from winning streak
    if (indexInWins !== -1 && newEntry.returnCash < 0) $b33589c348b8bea3$var$user.streaks.wins.trades.splice(indexInWins, 1);
    // current streak - checks whether the entry exists in the streak
    const indexInCurrent = $b33589c348b8bea3$var$user.streaks.current.trades ? $b33589c348b8bea3$var$user.streaks.current.trades.map((cur)=>cur.id).indexOf(newEntry.id) : -1;
    if (indexInCurrent !== -1) {
        const currentStreakLength = $b33589c348b8bea3$var$user.streaks.current.trades.length;
        // if the current streak is 1, overwrite the index as the new Entry already exists in the array
        if (currentStreakLength === 1) {
            $b33589c348b8bea3$var$user.streaks.current.trades[indexInCurrent] = streakObj;
            return;
        }
        // checks if new Entry's cash return is positive and the previous or next element's cash return is also positive
        // if this is the case, overwrite the index as the new Entry already exists in the array
        console.log(newEntry.returnCash);
        if (newEntry.returnCash > -1 && ($b33589c348b8bea3$var$user.streaks.current.trades[indexInCurrent - 1]?.returnCash > -1 || $b33589c348b8bea3$var$user.streaks.current.trades[indexInCurrent + 1]?.returnCash > -1)) {
            $b33589c348b8bea3$var$user.streaks.current.trades[indexInCurrent] = streakObj;
            return;
        }
        // checks if new Entry's cash return is positive and the previous or next element's cash return is negative
        // if this is the case, the streak is broken, so remove the existing new entry index from the array
        if (newEntry.returnCash > -1 && ($b33589c348b8bea3$var$user.streaks.current.trades[indexInCurrent - 1]?.returnCash < 0 || $b33589c348b8bea3$var$user.streaks.current.trades[indexInCurrent + 1]?.returnCash < 0)) {
            $b33589c348b8bea3$var$user.streaks.current.trades.splice(indexInCurrent, 1);
            return;
        }
        // checks if new Entry's cash return is negative and the previous or next element's cash return is also negative
        // if this is the case, overwrite the index as the new Entry already exists in the array
        if (newEntry.returnCash < 0 && ($b33589c348b8bea3$var$user.streaks.current.trades[indexInCurrent - 1].returnCash < 0 || $b33589c348b8bea3$var$user.streaks.current.trades[indexInCurrent + 1].returnCash < 0)) {
            $b33589c348b8bea3$var$user.streaks.current.trades[indexInCurrent] = streakObj;
            return;
        }
        // checks if new Entry's cash return is negative and the previous or next element's cash return is positive
        // if this is the case, the streak is broken, so remove the existing new entry index from the array
        if (newEntry.returnCash < 0 && ($b33589c348b8bea3$var$user.streaks.current.trades[indexInCurrent - 1].returnCash > -1 || $b33589c348b8bea3$var$user.streaks.current.trades[indexInCurrent + 1].returnCash > -1)) {
            $b33589c348b8bea3$var$user.streaks.current.trades.splice(indexInCurrent, 1);
            return;
        }
    }
    // check new entry against current streak
    // the existing entries and the new entry are both positive/negative, so push to the array
    if ($b33589c348b8bea3$var$user.streaks.current.trades[0] && newEntry.returnCash > -1 && $b33589c348b8bea3$var$user.streaks.current.trades[0].returnCash > -1) $b33589c348b8bea3$var$user.streaks.current.trades.push(streakObj);
    else if (// the existing entriees and the new entry are not both positive/negative, so override the array
    $b33589c348b8bea3$var$user.streaks.current.trades[0] && newEntry.returnCash > -1 && $b33589c348b8bea3$var$user.streaks.current.trades[0].returnCash < 0) $b33589c348b8bea3$var$user.streaks.current.trades = [
        streakObj
    ];
    // the existing entries and the new entry are both positive/negative, so push to the array
    if ($b33589c348b8bea3$var$user.streaks.current.trades[0] && newEntry.returnCash < 0 && $b33589c348b8bea3$var$user.streaks.current.trades[0].returnCash < 0) $b33589c348b8bea3$var$user.streaks.current.trades.push(streakObj);
    else if (// the existing entriees and the new entry are not both positive/negative, so override the array
    $b33589c348b8bea3$var$user.streaks.current.trades[0] && newEntry.returnCash < 0 && $b33589c348b8bea3$var$user.streaks.current.trades[0].returnCash > -1) $b33589c348b8bea3$var$user.streaks.current.trades = [
        streakObj
    ];
    // compare the current streak to winning and losing streak
    if ($b33589c348b8bea3$var$user.streaks.current.trades.length > 0) {
        if (// checks if the entries in the current streak are positive and if the current streak is longer than the winning streak
        // if this is the case, the current streak becomes the new winning streak
        $b33589c348b8bea3$var$user.streaks.current.trades[0].returnCash > -1 && $b33589c348b8bea3$var$user.streaks.current.trades.length > $b33589c348b8bea3$var$user.streaks.wins.trades.length + 1) {
            $b33589c348b8bea3$var$user.streaks.wins.trades = $b33589c348b8bea3$var$user.streaks.current.trades;
            return;
        }
        if (// checks if the entries in the current streak are negative and if the current streak is longer than the losing streak
        // if this is the case, the current streak becomes the new losing streak
        $b33589c348b8bea3$var$user.streaks.current.trades[0].returnCash < 0 && $b33589c348b8bea3$var$user.streaks.current.trades.length > $b33589c348b8bea3$var$user.streaks.losses.trades.length + 1) {
            $b33589c348b8bea3$var$user.streaks.losses.trades = $b33589c348b8bea3$var$user.streaks.current.trades;
            return;
        }
    } else // if the current streak is empty, push the entry
    $b33589c348b8bea3$var$user.streaks.current.trades.push(streakObj);
};
const $b33589c348b8bea3$var$compareToWorstBest = function(newEntry) {
    // best comparison
    if (newEntry.returnCash > -1) {
        const indexInBest = $b33589c348b8bea3$var$user.bestTrades.map((trade)=>trade.id).indexOf(newEntry.id);
        if (indexInBest !== -1) {
            $b33589c348b8bea3$var$user.bestTrades[indexInBest] = newEntry;
            $b33589c348b8bea3$var$user.bestTrades = $b33589c348b8bea3$var$user.bestTrades.sort((a, b)=>b.returnCash - a.returnCash);
            return;
        }
        $b33589c348b8bea3$var$user.bestTrades.push({
            id: newEntry.id,
            dateLong: newEntry.dateLong,
            dateShort: newEntry.dateShort,
            ticker: newEntry.ticker,
            returnCash: newEntry.returnCash
        });
        $b33589c348b8bea3$var$user.bestTrades = $b33589c348b8bea3$var$user.bestTrades.sort((a, b)=>b.returnCash - a.returnCash);
        if ($b33589c348b8bea3$var$user.bestTrades.length > 16) $b33589c348b8bea3$var$user.bestTrades.pop();
    }
    // worst comparison
    if (newEntry.returnCash < 0) {
        const indexInWorst = $b33589c348b8bea3$var$user.worstTrades.map((trade)=>trade.id).indexOf(newEntry.id);
        if (indexInWorst !== -1) {
            $b33589c348b8bea3$var$user.worstTrades[indexInWorst] = newEntry;
            $b33589c348b8bea3$var$user.worstTrades = $b33589c348b8bea3$var$user.worstTrades.sort((a, b)=>a.returnCash - b.returnCash);
            return;
        }
        $b33589c348b8bea3$var$user.worstTrades.push({
            id: newEntry.id,
            dateLong: newEntry.dateLong,
            dateShort: newEntry.dateShort,
            ticker: newEntry.ticker,
            returnCash: newEntry.returnCash
        });
        $b33589c348b8bea3$var$user.worstTrades = $b33589c348b8bea3$var$user.worstTrades.sort((a, b)=>a.returnCash - b.returnCash);
        if ($b33589c348b8bea3$var$user.worstTrades.length > 16) $b33589c348b8bea3$var$user.worstTrades.pop();
    }
};
const $b33589c348b8bea3$var$addToTickers = function(entry) {
    // if the current ticker and previous ticker don't match, meaning the ticker has changed
    if (entry.ticker !== entry.previousTicker && entry.previousTicker.length > 0) {
        let previousTicker = $b33589c348b8bea3$var$user.tickers[entry.previousTicker];
        const tradesIndex = $b33589c348b8bea3$var$user.tickers[entry.previousTicker].trades.map((trade)=>trade.id).indexOf(entry.id);
        if (tradesIndex !== -1) $b33589c348b8bea3$var$user.tickers[entry.previousTicker].trades.splice(tradesIndex, 1);
    }
    entry.previousTicker = entry.ticker;
    let currentTicker = $b33589c348b8bea3$var$user.tickers[entry.ticker];
    // if the ticker already exists in the array
    if (currentTicker) {
        const indexInTrades = currentTicker.trades.map((trade)=>trade.id).indexOf(entry.id);
        if (indexInTrades !== -1) currentTicker.trades[indexInTrades] = {
            id: entry.id,
            shares: entry.sharesAmount,
            returnCash: entry.returnCash,
            returnPercent: entry.returnPercent
        };
        if (indexInTrades === -1) currentTicker.trades.push({
            id: entry.id,
            shares: entry.sharesAmount,
            returnCash: entry.returnCash,
            returnPercent: entry.returnPercent
        });
        currentTicker.avgReturn = +(currentTicker.trades.map((trade)=>trade.returnCash).reduce((acc, num)=>acc + num, 0) / currentTicker.trades.length).toFixed(2);
    }
    // if the ticker is new
    if (!currentTicker) $b33589c348b8bea3$var$user.tickers[entry.ticker] = {
        ticker: entry.ticker,
        avgReturn: entry.returnCash,
        trades: [
            {
                id: entry.id,
                shares: entry.sharesAmount,
                returnCash: entry.returnCash,
                returnPercent: entry.returnPercent
            }
        ]
    };
};
const $b33589c348b8bea3$var$addToCalendarData = function(entry) {
    // if the currentDate and previousDate don't match, this means the date has changed
    if (entry.dateShort !== entry.previousDateShort && entry.previousDateShort.length > 0) {
        const previousDateKey = (0, $fZ5A9.MONTHS_FORMAT)[new Date(entry.previousDateLong).getMonth()] + String(new Date(entry.previousDateLong).getFullYear()).slice(-2);
        const previousDateIndex = $b33589c348b8bea3$var$user.calendarData[previousDateKey].map((day)=>day.dateShort).indexOf(entry.previousDateShort);
        let tradeIndex;
        if (previousDateIndex !== -1) tradeIndex = $b33589c348b8bea3$var$user.calendarData[previousDateKey][previousDateIndex].trades.map((trade)=>trade.id).indexOf(entry.id);
        if (tradeIndex !== -1) $b33589c348b8bea3$var$user.calendarData[previousDateKey][previousDateIndex].trades.splice(tradeIndex, 1);
        // check if this was the last trade for the date
        if ($b33589c348b8bea3$var$user.calendarData[previousDateKey][previousDateIndex].trades.length < 1) $b33589c348b8bea3$var$user.calendarData[previousDateKey].splice(previousDateIndex, 1);
        // check if month key doesn't have any more trades
        if ($b33589c348b8bea3$var$user.calendarData[previousDateKey].length < 1) delete $b33589c348b8bea3$var$user.calendarData[previousDateKey];
    }
    entry.previousDateShort = entry.dateShort;
    entry.previousDateLong = entry.dateLong;
    const dateKey = (0, $fZ5A9.MONTHS_FORMAT)[new Date(entry.dateLong).getMonth()] + String(new Date(entry.dateLong).getFullYear()).slice(-2);
    const currentKey = $b33589c348b8bea3$var$user.calendarData[dateKey];
    if (currentKey) {
        const entryDateIndex = currentKey.map((day)=>day.dateShort).indexOf(entry.dateShort);
        if (entryDateIndex !== -1) {
            const entryIDinTrades = currentKey[entryDateIndex].trades.map((trade)=>trade.id).indexOf(entry.id);
            if (entryIDinTrades !== -1) currentKey[entryDateIndex].trades[entryIDinTrades] = {
                id: entry.id,
                side: entry.side,
                returnCash: entry.returnCash,
                returnPercent: entry.returnPercent,
                total: entry.total
            };
            else currentKey[entryDateIndex].trades.push({
                id: entry.id,
                side: entry.side,
                returnCash: entry.returnCash,
                returnPercent: entry.returnPercent,
                total: entry.total
            });
        }
        if (entryDateIndex === -1) currentKey.push({
            dateLong: entry.dateLong,
            dateShort: entry.dateShort,
            trades: [
                {
                    id: entry.id,
                    side: entry.side,
                    returnCash: entry.returnCash,
                    returnPercent: entry.returnPercent,
                    total: entry.total
                }
            ]
        });
    }
    if (!currentKey) $b33589c348b8bea3$var$user.calendarData[dateKey] = [
        {
            dateLong: entry.dateLong,
            dateShort: entry.dateShort,
            trades: [
                {
                    id: entry.id,
                    side: entry.side,
                    returnCash: entry.returnCash,
                    returnPercent: entry.returnPercent,
                    total: entry.total
                }
            ]
        }
    ];
};
const $b33589c348b8bea3$var$compareStatistics = function(entry, newEntryIndex, previousSide = "") {
    $b33589c348b8bea3$var$addToOverall(entry, newEntryIndex, previousSide);
    $b33589c348b8bea3$var$compareToStreaks(entry);
    $b33589c348b8bea3$var$compareToWorstBest(entry);
    $b33589c348b8bea3$var$addToTickers(entry);
    $b33589c348b8bea3$var$addToCalendarData(entry);
};
const $b33589c348b8bea3$export$b60d557ba3977c66 = function(field) {
    return $b33589c348b8bea3$var$user[field];
};
const $b33589c348b8bea3$export$c266ce09db86893a = function(field, field2) {
    if (field2) return {
        [field2]: $b33589c348b8bea3$var$user[field][field2]
    };
    else return $b33589c348b8bea3$var$user[field];
};
const $b33589c348b8bea3$export$d40bb6bd8ada8865 = function(amount = "", action = "") {
    if (amount && action) {
        if (action === "minus") {
            if ($b33589c348b8bea3$var$user.journal.length > 0) {
                const lastJournalTrade = $b33589c348b8bea3$var$user.journal[$b33589c348b8bea3$var$user.journal.length - 1];
                lastJournalTrade.total -= Math.round(amount);
                $b33589c348b8bea3$var$user.capital = Math.round(lastJournalTrade.total);
                lastJournalTrade.capitalChange = -Math.abs(amount);
            } else $b33589c348b8bea3$var$user.capital -= Math.round(amount);
        }
        if (action === "plus") {
            if ($b33589c348b8bea3$var$user.journal.length > 0) {
                const lastJournalTrade = $b33589c348b8bea3$var$user.journal[$b33589c348b8bea3$var$user.journal.length - 1];
                lastJournalTrade.total += Math.round(amount);
                $b33589c348b8bea3$var$user.capital = Math.round(lastJournalTrade.total);
                lastJournalTrade.capitalChange = Math.abs(amount);
            } else $b33589c348b8bea3$var$user.capital += Math.round(amount);
        }
        if (action === "plus" && $b33589c348b8bea3$var$user.newAccount) {
            $b33589c348b8bea3$var$user.initialCapital += Math.round(amount);
            $b33589c348b8bea3$var$user.newAccount = false;
        }
        return [
            action,
            (0, $ge6e3.stringifyNum)(amount),
            (0, $ge6e3.stringifyNum)($b33589c348b8bea3$var$user.capital)
        ];
    }
    $b33589c348b8bea3$var$user.capital = Math.round($b33589c348b8bea3$var$user.journal[$b33589c348b8bea3$var$user.journal.length - 1].total);
};
const $b33589c348b8bea3$export$c3abfd45def62049 = function(obj) {
    Object.keys(obj).forEach((key)=>{
        $b33589c348b8bea3$var$user.calendarData[key] = obj[key];
    });
    return $b33589c348b8bea3$var$user.calendarData;
};
const $b33589c348b8bea3$export$420fe83f4630f7b6 = function(newEntry) {
    const newEntryIndex = $b33589c348b8bea3$var$user.journal.map((e)=>e.id).indexOf(newEntry.id);
    let previousSide;
    // if the id already exists, meaning the journal entry has been updated
    if (newEntryIndex !== -1) {
        newEntry.total = $b33589c348b8bea3$var$user.capital;
        previousSide = $b33589c348b8bea3$var$user.journal[newEntryIndex].side;
        // previous tickers and dates
        const previousTicker = $b33589c348b8bea3$var$user.journal[newEntryIndex].ticker;
        const previousDateShort = $b33589c348b8bea3$var$user.journal[newEntryIndex].dateShort;
        const previousDateLong = $b33589c348b8bea3$var$user.journal[newEntryIndex].dateLong;
        $b33589c348b8bea3$var$user.journal[newEntryIndex] = newEntry;
        $b33589c348b8bea3$var$user.journal[newEntryIndex].previousTicker = previousTicker;
        $b33589c348b8bea3$var$user.journal[newEntryIndex].previousDateShort = previousDateShort;
        $b33589c348b8bea3$var$user.journal[newEntryIndex].previousDateLong = previousDateLong;
        $b33589c348b8bea3$var$sortJournal($b33589c348b8bea3$var$user.journal);
        $b33589c348b8bea3$var$updateJournalTradesTotals();
        $b33589c348b8bea3$export$d40bb6bd8ada8865();
    }
    // newEntryIndex is -1, meaning the journal entry is new
    if (newEntryIndex === -1) {
        $b33589c348b8bea3$var$user.journal.push(newEntry);
        // sort the data
        $b33589c348b8bea3$var$sortJournal($b33589c348b8bea3$var$user.journal);
        $b33589c348b8bea3$var$updateJournalTradesTotals();
        $b33589c348b8bea3$export$d40bb6bd8ada8865();
    }
    $b33589c348b8bea3$var$compareStatistics(newEntry, newEntryIndex, previousSide);
    return [
        $b33589c348b8bea3$var$user.capital
    ];
};
const $b33589c348b8bea3$var$updateJournalTradesTotals = function() {
    $b33589c348b8bea3$var$user.journal.forEach((trade, index, arr)=>{
        if (index != 0) {
            $b33589c348b8bea3$var$user.journal[index].total = $b33589c348b8bea3$var$user.journal[index - 1].total + trade.returnCash;
            if ($b33589c348b8bea3$var$user.journal[index].capitalChange) $b33589c348b8bea3$var$user.journal[index].total += $b33589c348b8bea3$var$user.journal[index].capitalChange;
        // return;
        } else {
            $b33589c348b8bea3$var$user.journal[index].total = $b33589c348b8bea3$var$user.initialCapital + trade.returnCash;
            if ($b33589c348b8bea3$var$user.journal[index].capitalChange) $b33589c348b8bea3$var$user.journal[index].total += $b33589c348b8bea3$var$user.journal[index].capitalChange;
        }
    });
};
const $b33589c348b8bea3$export$925ab5cb31bc2750 = function(id) {
    if (!id) return;
    return $b33589c348b8bea3$var$user.journal.filter((entry)=>entry.id === id);
};
const $b33589c348b8bea3$export$539b580c1d8ce0cb = function(entryID) {
    // const [foundEntry] = user.journal.filter(entry => entry.id === entryID);
    const IndexInJournal = $b33589c348b8bea3$var$user.journal.map((journal)=>journal.id).indexOf(entryID);
    const foundEntry = $b33589c348b8bea3$var$user.journal[IndexInJournal];
    // journal
    $b33589c348b8bea3$var$user.journal.splice(IndexInJournal, 1);
    $b33589c348b8bea3$var$sortJournal($b33589c348b8bea3$var$user.journal);
    $b33589c348b8bea3$export$d40bb6bd8ada8865();
    $b33589c348b8bea3$var$updateJournalTradesTotals();
    // overall
    if (foundEntry.side === "short") $b33589c348b8bea3$var$user.overall.proportions[1].total--;
    if (foundEntry.side === "long") $b33589c348b8bea3$var$user.overall.proportions[0].total--;
    $b33589c348b8bea3$var$user.overall.total--;
    // streaks
    const indexInWinsStreak = $b33589c348b8bea3$var$user.streaks.wins.trades.map((trade)=>trade.id).indexOf(entryID);
    if (indexInWinsStreak !== -1) $b33589c348b8bea3$var$user.streaks.wins.trades.splice(indexInWinsStreak, 1);
    const indexInLossStreak = $b33589c348b8bea3$var$user.streaks.losses.trades.map((trade)=>trade.id).indexOf(entryID);
    if (indexInLossStreak !== -1) $b33589c348b8bea3$var$user.streaks.losses.trades.splice(indexInWinsStreak, 1);
    const indexInCurrentStreak = $b33589c348b8bea3$var$user.streaks.current.trades.map((trade)=>trade.id).indexOf(entryID);
    if (indexInCurrentStreak !== -1) $b33589c348b8bea3$var$user.streaks.current.trades.splice(indexInCurrentStreak, 1);
    // worst and best trades
    const indexInWorst = $b33589c348b8bea3$var$user.worstTrades.map((trade)=>trade.id).indexOf(entryID);
    if (indexInWorst !== -1) $b33589c348b8bea3$var$user.worstTrades.splice(indexInWorst, 1);
    const indexInBest = $b33589c348b8bea3$var$user.bestTrades.map((trade)=>trade.id).indexOf(entryID);
    if (indexInBest !== -1) $b33589c348b8bea3$var$user.bestTrades.splice(indexInBest, 1);
    // tickers
    const indexInTickers = $b33589c348b8bea3$var$user.tickers[foundEntry.ticker].trades.map((trade)=>trade.id).indexOf(entryID);
    if (indexInTickers !== -1) $b33589c348b8bea3$var$user.tickers[foundEntry.ticker].trades.splice(indexInTickers, 1);
    // calendar data
    const dateKey = (0, $fZ5A9.MONTHS_FORMAT)[new Date(foundEntry.dateLong).getMonth()] + String(new Date(foundEntry.dateLong).getFullYear()).slice(-2);
    const indexInCalendar = $b33589c348b8bea3$var$user.calendarData[dateKey].map((day)=>day.dateShort).indexOf(foundEntry.dateShort);
    if (indexInCalendar !== -1) {
        const indexInTrades = $b33589c348b8bea3$var$user.calendarData[dateKey][indexInCalendar].trades.map((trade)=>trade.id).indexOf(entryID);
        if (indexInTrades !== -1) $b33589c348b8bea3$var$user.calendarData[dateKey][indexInCalendar].trades.splice(indexInTrades, 1);
    }
    // check if this was the last trade for the date
    if ($b33589c348b8bea3$var$user.calendarData[dateKey][indexInCalendar].trades.length < 1) $b33589c348b8bea3$var$user.calendarData[dateKey].splice(indexInCalendar, 1);
    // check if month key doesn't have any more trades
    if ($b33589c348b8bea3$var$user.calendarData[dateKey].length < 1) delete $b33589c348b8bea3$var$user.calendarData[dateKey];
    console.log($b33589c348b8bea3$var$user);
};
const $b33589c348b8bea3$export$1b8cd2d0ef9a8e5d = function() {
    // localStorage.setItem('TikerData', JSON.stringify(user));
    console.log($b33589c348b8bea3$var$user);
};


let $31bd2817d4b028c5$var$coreEls = {};
const $31bd2817d4b028c5$var$getElements = function(obj = {}) {
    obj.core = document.querySelector(".js-core");
    obj.nav = obj.core.querySelector(".js-nav");
    obj.navTrigger = obj.core.querySelector(".js-nav-trigger");
    obj.loadingScreen = obj.core.querySelector(".js-loading");
    obj.singleBtnPopup = obj.core.querySelector(".js-single-btn-popup");
    obj.doubleBtnPopup = obj.core.querySelector(".js-double-btn-popup");
    obj.singleBtnPopupOkBtn = obj.core.querySelector(".js-popup-ok-btn");
    obj.doubleBtnPopupYesBtn = obj.core.querySelector(".js-popup-yes-btn");
    obj.doubleBtnPopupNoBtn = obj.core.querySelector(".js-popup-no-btn");
    obj.sectionOverview = obj.core.querySelector(".js-section-overview");
    obj.sectionMonthly = obj.core.querySelector(".js-section-monthly");
    obj.sectionJournal = obj.core.querySelector(".js-section-journal");
    obj.sectionCalculators = obj.core.querySelector(".js-section-calculators");
    obj.sectionSettings = obj.core.querySelector(".js-section-settings");
    obj.sectionHelp = obj.core.querySelector(".js-section-help");
    obj.performanceChart = obj.core.querySelector(".js-chart-performance");
    obj.overallChart = obj.core.querySelector(".js-chart-overall");
    obj.tableProfitable = obj.core.querySelector(".js-table-profitable");
    obj.worstBestChart = obj.core.querySelector(".js-chart-worst-best");
    return obj;
};
const $31bd2817d4b028c5$var$hideAllSections = function() {
    [
        $31bd2817d4b028c5$var$coreEls.sectionOverview,
        $31bd2817d4b028c5$var$coreEls.sectionMonthly,
        $31bd2817d4b028c5$var$coreEls.sectionJournal,
        $31bd2817d4b028c5$var$coreEls.sectionCalculators,
        $31bd2817d4b028c5$var$coreEls.sectionSettings,
        $31bd2817d4b028c5$var$coreEls.sectionHelp
    ].forEach((section)=>section.classList.add("s-core-hidden-section"));
};
const $31bd2817d4b028c5$var$toggleActiveNavBtns = function(targetEl) {
    $31bd2817d4b028c5$var$coreEls.nav.querySelector(".btn--nav--active").classList.remove("btn--nav--active");
    targetEl.classList.add("btn--nav--active");
};
const $31bd2817d4b028c5$export$d478bd899ecaa824 = function(...messages) {
    $31bd2817d4b028c5$var$coreEls.singleBtnPopup.classList.add("s-content__popup--active");
    const popupContentWrapper = $31bd2817d4b028c5$var$coreEls.singleBtnPopup.children[0];
    messages.forEach((message)=>{
        const html = `
      <p class="s-content__popup-text">${message}</p>
    `;
        popupContentWrapper.insertAdjacentHTML("afterbegin", html);
    });
};
const $31bd2817d4b028c5$export$aff20287cfa3135e = function(entryID = "", source = "", ...messages) {
    $31bd2817d4b028c5$var$coreEls.doubleBtnPopup.classList.add("s-content__popup--active");
    $31bd2817d4b028c5$var$coreEls.doubleBtnPopup.setAttribute("source", source);
    $31bd2817d4b028c5$var$coreEls.doubleBtnPopup.setAttribute("entry-id", entryID);
    const popupContentWrapper = $31bd2817d4b028c5$var$coreEls.doubleBtnPopup.children[0];
    messages.forEach((message)=>{
        const html = `
      <p class="s-content__popup-text">${message}</p>
    `;
        popupContentWrapper.insertAdjacentHTML("afterbegin", html);
    });
};
const $31bd2817d4b028c5$export$bba5038aab73375b = function() {
    const activePopup = $31bd2817d4b028c5$var$coreEls.core.querySelector(".s-content__popup--active");
    if (activePopup) {
        activePopup.children[0].querySelectorAll("p").forEach((text)=>text.remove());
        activePopup.classList.remove("s-content__popup--active");
    }
};
const $31bd2817d4b028c5$export$86eb99e836e70b77 = function() {
    $31bd2817d4b028c5$var$coreEls.loadingScreen.remove();
};
const $31bd2817d4b028c5$export$ac96e30d6d6c1be4 = function() {
    $31bd2817d4b028c5$var$coreEls = $31bd2817d4b028c5$var$getElements();
};
const $31bd2817d4b028c5$export$9c0b5467ca05928c = function(handler) {
    $31bd2817d4b028c5$var$coreEls.nav.addEventListener("click", (e)=>handler(e.target));
};
const $31bd2817d4b028c5$export$e322dd3310a00bc9 = function() {
    $31bd2817d4b028c5$var$coreEls.nav.classList.toggle("c-nav--is-active");
};
const $31bd2817d4b028c5$export$5c73b62e7604c855 = function(handler) {
    $31bd2817d4b028c5$var$coreEls.navTrigger.addEventListener("click", ()=>handler());
};
const $31bd2817d4b028c5$export$83b746114fb11012 = function(handler) {
    $31bd2817d4b028c5$var$coreEls.singleBtnPopupOkBtn.addEventListener("click", (e)=>{
        e.preventDefault();
        handler("hide");
    });
    $31bd2817d4b028c5$var$coreEls.singleBtnPopup.children[0].addEventListener("click", (e)=>{
        e.preventDefault();
        e.stopPropagation();
    });
    $31bd2817d4b028c5$var$coreEls.singleBtnPopup.addEventListener("click", (e)=>{
        e.preventDefault();
        handler("hide");
    });
    $31bd2817d4b028c5$var$coreEls.doubleBtnPopupNoBtn.addEventListener("click", (e)=>{
        e.preventDefault();
        handler("hide");
    });
    $31bd2817d4b028c5$var$coreEls.doubleBtnPopupYesBtn.addEventListener("click", (e)=>{
        e.stopPropagation();
        handler("proceed", $31bd2817d4b028c5$var$coreEls.doubleBtnPopup.getAttribute("source"), $31bd2817d4b028c5$var$coreEls.doubleBtnPopup.getAttribute("entry-id"));
    });
    $31bd2817d4b028c5$var$coreEls.doubleBtnPopup.children[0].addEventListener("click", (e)=>{
        e.preventDefault();
        e.stopPropagation();
    });
    $31bd2817d4b028c5$var$coreEls.doubleBtnPopup.addEventListener("click", (e)=>{
        e.preventDefault();
        handler("hide");
    });
};
const $31bd2817d4b028c5$export$65d711c204a27870 = function(targetEl) {
    if (targetEl.classList.contains("js-nav-overview-btn")) {
        $31bd2817d4b028c5$export$bba5038aab73375b();
        $31bd2817d4b028c5$var$hideAllSections();
        $31bd2817d4b028c5$var$coreEls.sectionOverview.classList.remove("s-core-hidden-section");
        $31bd2817d4b028c5$var$toggleActiveNavBtns(targetEl);
        return "rerender";
    }
    if (targetEl.classList.contains("js-nav-monthly-btn")) {
        $31bd2817d4b028c5$export$bba5038aab73375b();
        $31bd2817d4b028c5$var$hideAllSections();
        $31bd2817d4b028c5$var$coreEls.sectionMonthly.classList.remove("s-core-hidden-section");
        $31bd2817d4b028c5$var$toggleActiveNavBtns(targetEl);
    }
    if (targetEl.classList.contains("js-nav-journal-btn")) {
        $31bd2817d4b028c5$export$bba5038aab73375b();
        $31bd2817d4b028c5$var$hideAllSections();
        $31bd2817d4b028c5$var$coreEls.sectionJournal.classList.remove("s-core-hidden-section");
        $31bd2817d4b028c5$var$toggleActiveNavBtns(targetEl);
    }
    if (targetEl.classList.contains("js-nav-calculators-btn")) {
        $31bd2817d4b028c5$export$bba5038aab73375b();
        $31bd2817d4b028c5$var$hideAllSections();
        $31bd2817d4b028c5$var$coreEls.sectionCalculators.classList.remove("s-core-hidden-section");
        $31bd2817d4b028c5$var$toggleActiveNavBtns(targetEl);
    }
    if (targetEl.classList.contains("js-nav-settings-btn")) {
        $31bd2817d4b028c5$export$bba5038aab73375b();
        $31bd2817d4b028c5$var$hideAllSections();
        $31bd2817d4b028c5$var$coreEls.sectionSettings.classList.remove("s-core-hidden-section");
        $31bd2817d4b028c5$var$toggleActiveNavBtns(targetEl);
    }
    if (targetEl.classList.contains("js-nav-help-btn")) {
        $31bd2817d4b028c5$export$bba5038aab73375b();
        $31bd2817d4b028c5$var$hideAllSections();
        $31bd2817d4b028c5$var$coreEls.sectionHelp.classList.remove("s-core-hidden-section");
        $31bd2817d4b028c5$var$toggleActiveNavBtns(targetEl);
    }
    if (targetEl.classList.contains("js-nav-exit-btn")) {
        $31bd2817d4b028c5$export$bba5038aab73375b();
        $31bd2817d4b028c5$export$aff20287cfa3135e("", "logoff", "All unsaved progress will be lost", "Are you sure you want to log off?");
    }
};
const $31bd2817d4b028c5$export$2fb87bbf5418dbe1 = function() {
    $31bd2817d4b028c5$export$bba5038aab73375b();
    window.location.href = "../../index.html";
};
const $31bd2817d4b028c5$export$ca94f9cd30199838 = function() {
    [
        $31bd2817d4b028c5$var$coreEls.performanceChart,
        $31bd2817d4b028c5$var$coreEls.overallChart,
        $31bd2817d4b028c5$var$coreEls.tableProfitable,
        $31bd2817d4b028c5$var$coreEls.worstBestChart
    ].forEach((card)=>card.classList.add("s-content__no-data"));
};
const $31bd2817d4b028c5$export$d3874125acfa916 = function() {
    [
        $31bd2817d4b028c5$var$coreEls.performanceChart,
        $31bd2817d4b028c5$var$coreEls.overallChart,
        $31bd2817d4b028c5$var$coreEls.tableProfitable,
        $31bd2817d4b028c5$var$coreEls.worstBestChart
    ].forEach((card)=>card.classList.remove("s-content__no-data"));
};


let $5c945194c19474d5$var$calculatorEls = {};
const $5c945194c19474d5$var$getElements = function(obj = {}) {
    obj.calcPosition = document.querySelector(".js-calc-position");
    obj.positionEntryPrice = obj.calcPosition.querySelector(".js-calc-position-entry");
    obj.positionRiskPercentage = obj.calcPosition.querySelector(".js-calc-position-percentage");
    obj.positionStopPrice = obj.calcPosition.querySelector(".js-calc-position-stop");
    obj.positionResult = obj.calcPosition.querySelector(".js-calc-position-result");
    obj.calcRatio = document.querySelector(".js-calc-ratio");
    obj.ratioEntryPrice = obj.calcRatio.querySelector(".js-calc-ratio-entry");
    obj.ratioExitPrice = obj.calcRatio.querySelector(".js-calc-ratio-exit");
    obj.ratioStopPrice = obj.calcRatio.querySelector(".js-calc-ratio-stop");
    obj.ratioResult = obj.calcRatio.querySelector(".js-calc-ratio-result");
    obj.calcCapital = document.querySelector(".js-calc-capital");
    obj.capitalSign = obj.calcCapital.querySelector(".js-calc-capital-sign");
    obj.capitalSignBtn = obj.calcCapital.querySelector(".js-calc-capital-sign-btn");
    obj.capitalInput = obj.calcCapital.querySelector(".js-calc-capital-input");
    obj.capitalUpdateBtn = obj.calcCapital.querySelector(".js-calc-capital-update-btn");
    obj.capitalMessage = obj.calcCapital.querySelector(".js-calc-capital-message");
    return obj;
};
const $5c945194c19474d5$export$6e4d76765bcebd1b = function() {
    $5c945194c19474d5$var$calculatorEls = $5c945194c19474d5$var$getElements();
};
const $5c945194c19474d5$var$checkFieldsForData = function(el1, el2, el3) {
    if (!el1.value || !el2.value || !el3.value) return;
    return [
        +el1.value,
        +el2.value,
        +el3.value
    ];
};
const $5c945194c19474d5$export$6067ee6b47f9a18f = function(handler) {
    $5c945194c19474d5$var$calculatorEls.capitalUpdateBtn.addEventListener("click", (e)=>{
        const amount = +$5c945194c19474d5$var$calculatorEls.capitalInput.value;
        if (!amount || isNaN(amount)) return;
        handler(amount, $5c945194c19474d5$var$calculatorEls.capitalSign.getAttribute("data-action"));
    });
    $5c945194c19474d5$var$calculatorEls.capitalSignBtn.addEventListener("click", (e)=>{
        if (e.target.previousElementSibling.getAttribute("data-action") === "plus") {
            $5c945194c19474d5$var$calculatorEls.capitalSign.innerHTML = `
      <svg class="svg svg--minus" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
        <rect y="5" width="13" height="3" fill="#C4C4C4"/>
      </svg>
      `;
            $5c945194c19474d5$var$calculatorEls.capitalSign.setAttribute("data-action", "minus");
        } else {
            $5c945194c19474d5$var$calculatorEls.capitalSign.innerHTML = `
      <svg class="svg svg--plus" viewBox="0 0 13 13"
        xmlns="http://www.w3.org/2000/svg">
        <rect y="5" width="13" height="3" fill="#C4C4C4" />
        <rect x="8" width="13" height="3" transform="rotate(90 8 0)" fill="#C4C4C4" />
      </svg>
      `;
            $5c945194c19474d5$var$calculatorEls.capitalSign.setAttribute("data-action", "plus");
        }
    });
};
const $5c945194c19474d5$export$ae25a6d41d7c5d04 = function(handler) {
    [
        $5c945194c19474d5$var$calculatorEls.positionEntryPrice,
        $5c945194c19474d5$var$calculatorEls.positionRiskPercentage,
        $5c945194c19474d5$var$calculatorEls.positionStopPrice
    ].forEach((input)=>{
        input.addEventListener("keyup", (e)=>{
            if (e.key === "Tab" || !isFinite(e.key) && e.key !== "Backspace") return;
            const formattedData = $5c945194c19474d5$var$checkFieldsForData($5c945194c19474d5$var$calculatorEls.positionEntryPrice, $5c945194c19474d5$var$calculatorEls.positionRiskPercentage, $5c945194c19474d5$var$calculatorEls.positionStopPrice);
            handler(formattedData);
        });
    });
};
const $5c945194c19474d5$export$ae96ffaca1b313ed = function(handler) {
    [
        $5c945194c19474d5$var$calculatorEls.ratioEntryPrice,
        $5c945194c19474d5$var$calculatorEls.ratioExitPrice,
        $5c945194c19474d5$var$calculatorEls.ratioStopPrice
    ].forEach((input)=>{
        input.addEventListener("keyup", (e)=>{
            if (e.key === "Tab" || !isFinite(e.key) && e.key !== "Backspace") return;
            const formattedData = $5c945194c19474d5$var$checkFieldsForData($5c945194c19474d5$var$calculatorEls.ratioEntryPrice, $5c945194c19474d5$var$calculatorEls.ratioExitPrice, $5c945194c19474d5$var$calculatorEls.ratioStopPrice);
            handler(formattedData);
        });
    });
};
const $5c945194c19474d5$export$2f2fc3119d24f888 = function(arr) {
    const spanEls = $5c945194c19474d5$var$calculatorEls.capitalMessage.querySelectorAll("span");
    spanEls[0].textContent = arr[0] === "plus" ? "added" : "removed";
    spanEls[1].textContent = arr[1];
    spanEls[2].textContent = arr[2];
    $5c945194c19474d5$var$calculatorEls.capitalMessage.classList.add("c-calculator-capital__message--is-active");
    setTimeout(()=>{
        $5c945194c19474d5$var$calculatorEls.capitalMessage.classList.remove("c-calculator-capital__message--is-active");
        $5c945194c19474d5$var$calculatorEls.capitalInput.value = "";
    }, 6000);
};
const $5c945194c19474d5$export$3c09fca5a796c0a3 = function(result, el) {
    $5c945194c19474d5$var$calculatorEls[el].value = result;
};
const $5c945194c19474d5$export$b67e165217167740 = function(el) {
    $5c945194c19474d5$var$calculatorEls[el].value = "";
};



var $ge6e3 = parcelRequire("ge6e3");
const $03827f1b7c3185bc$export$44b0c40bdeb407b0 = function(accountCapital, dataArr) {
    const [entry, risk, stop] = dataArr;
    const moneyRisk = accountCapital * (risk * 0.01);
    const stopDistance = (0, $ge6e3.makeAbsolute)(entry - stop);
    return stopDistance !== 0 ? Math.round(moneyRisk / stopDistance) : 0;
};
const $03827f1b7c3185bc$export$c23150291e680048 = function(dataArr) {
    const [entry, exit, stop] = dataArr;
    if (dataArr.sort((a, b)=>a - b).indexOf(entry) !== 1) return;
    const exitDistance = (0, $ge6e3.makeAbsolute)(exit - entry);
    const stopDistance = (0, $ge6e3.makeAbsolute)(entry - stop);
    return (exitDistance / stopDistance).toFixed(2);
};


let $53cfc6b9034ec443$var$monthlyEls = {};
const $53cfc6b9034ec443$var$getElements = function(obj = {}) {
    obj.monthlyTable = document.querySelector(".js-monthly-table");
    obj.monthlyTableHead = obj.monthlyTable.querySelector(".js-monthly-table-head");
    return obj;
};
const $53cfc6b9034ec443$export$7ace4912664725f5 = function() {
    $53cfc6b9034ec443$var$monthlyEls = $53cfc6b9034ec443$var$getElements();
};
const $53cfc6b9034ec443$export$4b9e39c5b0ba6c40 = function(data) {
    if ($53cfc6b9034ec443$var$monthlyEls.monthlyTableRows) Array.from($53cfc6b9034ec443$var$monthlyEls.monthlyTableRows).forEach((row)=>row.remove());
    const keys = Object.keys(data);
    const sortedKeys = keys.map((key)=>[
            key,
            data[key].dateLong
        ]).sort((a, b)=>new Date(a[1]) - new Date(b[1])).map((key)=>key[0]);
    sortedKeys.forEach((key)=>{
        const current = data[key];
        const html = `
    <tr class="js-table-monthly-row">
        <th>${current.total.month}</th>
        <td class="${current.total.monthlyReturn >= 0 ? "" : "negative"}">${current.total.monthlyReturn.toFixed(2)}</td>
        <td>${current.total.totalTrades}</td>
        <td class="${current.total.avgReturn >= 0 ? "" : "negative"}">${current.total.avgReturn}</td>
        <td>${+current.total.avgWinPercent}%</td>
        <td>${+current.total.avgLossPercent}%</td>
        <td>${+current.total.battingAvg}%</td>
        <td>${current.total.winLossRatio}</td>
    </tr>
    <tr class="js-table-monthly-row">
        <th>${current.long.side}</th>
        <td class="${current.long.monthlyReturn >= 0 ? "" : "negative"}">${current.long.monthlyReturn.toFixed(2)}</td>
        <td>${current.long.totalTrades}</td>
        <td class="${current.long.avgReturn >= 0 ? "" : "negative"}">${current.long.avgReturn}</td>
        <td>${+current.long.avgWinPercent}%</td>
        <td>${+current.long.avgLossPercent}%</td>
        <td>${+current.long.battingAvg}%</td>
        <td>${current.long.winLossRatio}</td>
    </tr>
    <tr class="s-monthly__table-unit js-table-monthly-row">
        <th>${current.short.side}</th>
        <td class="${current.short.monthlyReturn >= 0 ? "" : "negative"}">${current.short.monthlyReturn.toFixed(2)}</td>
        <td>${current.short.totalTrades}</td>
        <td class="${current.short.avgReturn >= 0 ? "" : "negative"}">${current.short.avgReturn}</td>
        <td>${+current.short.avgWinPercent}%</td>
        <td>${+current.short.avgLossPercent}%</td>
        <td>${+current.short.battingAvg}%</td>
        <td>${current.short.winLossRatio}</td>
    </tr>
    `;
        $53cfc6b9034ec443$var$monthlyEls.monthlyTableHead.insertAdjacentHTML("afterend", html);
        $53cfc6b9034ec443$var$monthlyEls.monthlyTableRows = $53cfc6b9034ec443$var$monthlyEls.monthlyTable.querySelectorAll(".js-table-monthly-row");
    });
};



var $ge6e3 = parcelRequire("ge6e3");
let $bc029bfc0551362a$var$profitableEls = {};
const $bc029bfc0551362a$var$getElements = function(obj = {}) {
    obj.profitableTable = document.querySelector(".js-profitable-table");
    obj.profitableTableHead = obj.profitableTable.querySelector(".js-profitable-table-head");
    return obj;
};
const $bc029bfc0551362a$export$b6be05e0cf54d5d3 = function() {
    $bc029bfc0551362a$var$profitableEls = $bc029bfc0551362a$var$getElements();
};
const $bc029bfc0551362a$export$28abb260122841e0 = function(tableData) {
    $bc029bfc0551362a$var$profitableEls.profitableTableHead.parentElement.querySelectorAll("tr:not(:first-child)").forEach((row)=>row.remove());
    Object.keys(tableData).forEach((data)=>{
        const ticker = tableData[data];
        const html = `
        <tr>
            <th>${data}</th>
            <td>${ticker.totalProfit.toFixed(2)}</td>
            <td>${ticker.totalTrades}/${(0, $ge6e3.kFormatter)(ticker.totalShares, 9999)}</td>
            <td>${ticker.avgReturn}</td>
            <td>${ticker.avgWinPercent}</td>
            <td>${ticker.battingAvgPercent}</td>
            <td>${ticker.winLossRatio}</td>
        </tr>
      `;
        $bc029bfc0551362a$var$profitableEls.profitableTableHead.insertAdjacentHTML("afterend", html);
    });
};


parcelRequire("ge6e3");
let $507dc9d3b582608c$var$overallEls = {};
const $507dc9d3b582608c$var$getElements = function(obj = {}) {
    obj.pieStreakCard = document.querySelector(".js-pie-streak");
    obj.shortLongCanvas = document.querySelector(".js-pie-canvas");
    obj.winStreakDate = obj.pieStreakCard.querySelector(".js-win-streak-date");
    obj.winStreakTotal = obj.pieStreakCard.querySelector(".js-win-streak-total");
    obj.winStreakProfit = obj.pieStreakCard.querySelector(".js-win-streak-profit");
    obj.lossStreakDate = obj.pieStreakCard.querySelector(".js-loss-streak-date");
    obj.lossStreakTotal = obj.pieStreakCard.querySelector(".js-loss-streak-total");
    obj.lossStreakProfit = obj.pieStreakCard.querySelector(".js-loss-streak-profit");
    obj.overallTradesNumber = obj.pieStreakCard.querySelector(".js-overall-trades-number");
    obj.shortPositions = obj.pieStreakCard.querySelector(".js-short-positions");
    obj.longPositions = obj.pieStreakCard.querySelector(".js-long-positions");
    return obj;
};
const $507dc9d3b582608c$export$d9660c11a41b6e8e = function() {
    $507dc9d3b582608c$var$overallEls = $507dc9d3b582608c$var$getElements();
};
const $507dc9d3b582608c$export$74f677f40ed95de = function() {
    $507dc9d3b582608c$var$overallEls.shortLongCanvas.innerHTML = "";
};
const $507dc9d3b582608c$export$ff290589fa1cea4c = function(data) {
    $507dc9d3b582608c$var$overallEls.overallTradesNumber.textContent = data.total ? data.total : 0;
    if (data.proportions && data.proportions[0]) $507dc9d3b582608c$var$overallEls.longPositions.textContent = `${data.proportions[0].total} - ${(data.proportions[0].total / (data.total > 0 ? data.total : 1) * 100).toFixed(1)}%`;
    else $507dc9d3b582608c$var$overallEls.longPositions.textContent = "0 - 0%";
    if (data.proportions && data.proportions[1]) $507dc9d3b582608c$var$overallEls.shortPositions.textContent = `${data.proportions[1].total} - ${(data.proportions[1].total / (data.total > 0 ? data.total : 1) * 100).toFixed(1)}%`;
    else $507dc9d3b582608c$var$overallEls.shortPositions.textContent = "0 - 0%";
};
const $507dc9d3b582608c$export$d43dd3db639c38 = function(data) {
    $507dc9d3b582608c$var$overallEls.winStreakTotal.textContent = data.wins.trades ? data.wins.trades.length : 0;
    $507dc9d3b582608c$var$overallEls.winStreakProfit.textContent = data.wins.trades ? data.wins.trades.map((trade)=>trade.returnCash).reduce((acc, num)=>acc + num, 0).toFixed(2) : 0;
    $507dc9d3b582608c$var$overallEls.winStreakDate.textContent = `${data.wins.trades.length > 0 ? data.wins.trades[0].date : "xx/xx/xx"} - ${data.wins.trades.length > 0 ? data.wins.trades[data.wins.trades.length - 1].date : "xx/xx/xx"}`;
    $507dc9d3b582608c$var$overallEls.lossStreakTotal.textContent = data.losses.trades ? data.losses.trades.length : 0;
    $507dc9d3b582608c$var$overallEls.lossStreakProfit.textContent = data.losses.trades ? data.losses.trades.map((trade)=>trade.returnCash).reduce((acc, num)=>acc + num, 0).toFixed(2) : 0;
    $507dc9d3b582608c$var$overallEls.lossStreakDate.textContent = `${data.losses.trades.length > 0 ? data.losses.trades[0].date : "xx/xx/xx"} - ${data.losses.trades.length > 0 ? data.losses.trades[data.losses.trades.length - 1].date : "xx/xx/xx"}`;
};
// ZONE - D3
let $507dc9d3b582608c$var$pieData = [];
const $507dc9d3b582608c$export$17cae48d2b736b73 = function(passedData) {
    if (passedData) {
        $507dc9d3b582608c$var$pieData = passedData;
        $507dc9d3b582608c$export$74f677f40ed95de();
    } else passedData = $507dc9d3b582608c$var$pieData;
    const canvasRect = $507dc9d3b582608c$var$overallEls.shortLongCanvas.getBoundingClientRect();
    // create room for axes
    const margin = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    const graphWidth = canvasRect.width - margin.left - margin.right;
    const graphHeight = canvasRect.height - margin.top - margin.bottom;
    const graphRadius = canvasRect.height / 2.4;
    const graphCenter = {
        x: graphWidth / 2,
        y: graphHeight / 2
    };
    let totalTrades;
    if (passedData[1]) totalTrades = passedData[0].total + passedData[1].total;
    else totalTrades = passedData[0];
    const svg = d3.select(".js-pie-canvas").append("svg").attr("width", "100%").attr("height", graphHeight);
    // create a group to contain all graph elements
    const graph = svg.append("g").attr("transform", `translate(${graphCenter.x}, ${graphCenter.y})`);
    const pie = d3.pie().sort(null).value((d)=>d.total);
    // arc generator needs to know the start and end angles, which is why we created the pie function
    const arcPath = d3.arc().outerRadius(graphRadius).innerRadius(graphRadius / 4);
    // ZONE - update function
    const updateLongShortPie = function(passedData) {
        // join enhanced pie data to path elements
        const paths = graph.selectAll("path").data(pie(passedData));
        // remove unwanted paths
        paths.exit().remove();
        // enter elements
        paths.enter().append("path").attr("class", "pie-section").attr("d", arcPath);
        // existing DOM elements
        paths.attr("d", arcPath);
    };
    updateLongShortPie(passedData);
};


// import { reduce } from 'core-js/core/array';

var $ge6e3 = parcelRequire("ge6e3");
const $595a7b13736253d0$var$createPlaceholderObj = function(key) {
    return {
        dateLong: "",
        total: {
            month: key,
            monthlyReturn: [
                0
            ],
            totalTrades: 0,
            avgReturn: [],
            avgWinPercent: [],
            avgLossPercent: [],
            profitableNumber: 0,
            battingAvg: 0,
            winLossRatio: []
        },
        long: {
            side: "long",
            monthlyReturn: [
                0
            ],
            totalTrades: 0,
            avgReturn: [],
            avgWinPercent: [],
            avgLossPercent: [],
            profitableNumber: 0,
            battingAvg: [],
            winLossRatio: []
        },
        short: {
            side: "short",
            monthlyReturn: [
                0
            ],
            totalTrades: 0,
            avgReturn: [],
            avgWinPercent: [],
            avgLossPercent: [],
            profitableNumber: 0,
            battingAvg: [],
            winLossRatio: []
        }
    };
};
const $595a7b13736253d0$var$calcBattingAvg = function(profitable, total) {
    if (!profitable) profitable = 0;
    if (!total) total = 1;
    return Math.round(profitable / total * 100);
};
const $595a7b13736253d0$var$calcWinLossRatio = function(profitable, total) {
    if (!profitable) profitable = 0;
    if (!total) total = 1;
    if (profitable === total) total++;
    return (profitable / total).toFixed(2);
};
const $595a7b13736253d0$export$8254cbabffce0112 = function(rawData) {
    const formattedMonths = {};
    const keys = Object.keys(rawData);
    keys.forEach((key)=>{
        const currentMonth = rawData[key];
        let tableUnit = $595a7b13736253d0$var$createPlaceholderObj(key);
        tableUnit.dateLong = currentMonth[0].dateLong;
        // grab all the trades from that month and flatten into one array
        const flattenedDays = currentMonth.map((day)=>day.trades).flat();
        tableUnit.total.totalTrades = flattenedDays.length;
        flattenedDays.forEach((trade)=>{
            let currentSide; // decides which object to add data to
            if (trade.side === "long") currentSide = tableUnit.long;
            else if (trade.side === "short") currentSide = tableUnit.short;
            currentSide.monthlyReturn.push(trade.returnCash); // monthly return
            currentSide.totalTrades++; // total trades
            currentSide.avgReturn.push(trade.returnCash); // avg Return
            // avg win and loss %
            if (trade.returnPercent >= 0) {
                currentSide.avgWinPercent.push(trade.returnPercent);
                tableUnit.total.profitableNumber++;
                currentSide.profitableNumber++;
            } else if (trade.returnPercent <= 0) currentSide.avgLossPercent.push(trade.returnPercent);
        });
        // crunch the array data into single numbers
        tableUnit.long.monthlyReturn = (0, $ge6e3.reduceData)(tableUnit.long.monthlyReturn);
        tableUnit.long.avgReturn = (0, $ge6e3.crunchData)(tableUnit.long.avgReturn);
        tableUnit.long.avgWinPercent = (0, $ge6e3.crunchData)(tableUnit.long.avgWinPercent);
        tableUnit.long.avgLossPercent = (0, $ge6e3.crunchData)(tableUnit.long.avgLossPercent);
        tableUnit.short.monthlyReturn = (0, $ge6e3.reduceData)(tableUnit.short.avgReturn);
        tableUnit.short.avgReturn = (0, $ge6e3.crunchData)(tableUnit.short.avgReturn);
        tableUnit.short.avgWinPercent = (0, $ge6e3.crunchData)(tableUnit.short.avgWinPercent);
        tableUnit.short.avgLossPercent = (0, $ge6e3.crunchData)(tableUnit.short.avgLossPercent);
        tableUnit.total.monthlyReturn = (0, $ge6e3.reduceData)([
            tableUnit.long.monthlyReturn,
            tableUnit.short.monthlyReturn
        ]);
        tableUnit.total.avgReturn = (0, $ge6e3.crunchData)((0, $ge6e3.filterNonStrings)([
            tableUnit.long.avgReturn,
            tableUnit.short.avgReturn
        ]));
        tableUnit.total.avgWinPercent = (0, $ge6e3.crunchData)((0, $ge6e3.filterNonStrings)([
            tableUnit.long.avgWinPercent,
            tableUnit.short.avgWinPercent
        ]));
        tableUnit.total.avgLossPercent = (0, $ge6e3.crunchData)((0, $ge6e3.filterNonStrings)([
            tableUnit.long.avgLossPercent,
            tableUnit.short.avgLossPercent
        ]));
        // batting avg %
        tableUnit.long.battingAvg = $595a7b13736253d0$var$calcBattingAvg(tableUnit.long.profitableNumber, tableUnit.long.totalTrades);
        tableUnit.short.battingAvg = $595a7b13736253d0$var$calcBattingAvg(tableUnit.short.profitableNumber, tableUnit.short.totalTrades);
        tableUnit.total.battingAvg = $595a7b13736253d0$var$calcBattingAvg(tableUnit.total.profitableNumber, tableUnit.total.totalTrades);
        // win loss ratio
        tableUnit.long.winLossRatio = $595a7b13736253d0$var$calcWinLossRatio(tableUnit.long.profitableNumber, tableUnit.long.totalTrades);
        tableUnit.short.winLossRatio = $595a7b13736253d0$var$calcWinLossRatio(tableUnit.short.profitableNumber, tableUnit.short.totalTrades);
        tableUnit.total.winLossRatio = $595a7b13736253d0$var$calcWinLossRatio(tableUnit.total.profitableNumber, tableUnit.total.totalTrades);
        formattedMonths[key] = tableUnit;
    });
    return formattedMonths;
};


const $911163ba9bcb34be$var$convertToLeader = function(data) {
    const ticker = data.ticker;
    const formattedLeader = {
        totalTrades: data.trades.length,
        profitable: 0,
        totalProfit: 0,
        totalShares: 0,
        avgReturn: 0,
        avgWinPercent: 0,
        battingAvgPercent: 0,
        winLossRatio: 0
    };
    const current = formattedLeader;
    const tradeResults = data.trades.map((trade)=>trade.returnCash);
    const totalProfit = tradeResults.reduce((acc, num)=>acc + num, 0);
    const totalShares = data.trades.map((trade)=>trade.shares).reduce((acc, num)=>acc + num, 0);
    const winPercentTrades = data.trades.map((trade)=>trade.returnPercent).filter((percent)=>percent >= 0);
    current.totalProfit = totalProfit;
    current.totalShares = totalShares;
    current.avgReturn = +(totalProfit / current.totalTrades).toFixed(0);
    current.avgWinPercent = (winPercentTrades.reduce((acc, num)=>acc + num) / winPercentTrades.length).toFixed(2);
    current.profitable = winPercentTrades.length;
    current.battingAvgPercent = +(current.profitable / current.totalTrades * 100).toFixed(2);
    current.winLossRatio = +(current.profitable / (current.totalTrades - current.profitable)).toFixed(2);
    if (!isFinite(current.winLossRatio)) current.winLossRatio = data.trades.length;
    return formattedLeader;
};
const $911163ba9bcb34be$export$693324c8bf5b90cb = function(tickerData) {
    const sortedTickers = Object.values(tickerData).sort((a, b)=>a.avgReturn - b.avgReturn);
    const topSix = sortedTickers.filter((ticker)=>ticker.trades.length > 2).splice(0, 7);
    let leadersArray = {};
    topSix.forEach((leader)=>{
        if (leader.avgReturn > 0) {
            const leaderFormat = $911163ba9bcb34be$var$convertToLeader(leader);
            leadersArray[leader.ticker] = leaderFormat;
        }
    });
    return leadersArray;
};





var $ge6e3 = parcelRequire("ge6e3");
let $c1a9c97858d35935$var$performanceEls = {};
const $c1a9c97858d35935$var$getElements = function(obj = {}) {
    obj.performanceCanvas = document.querySelector(".js-performance-canvas");
    obj.performanceDayBtn = document.querySelector(".js-performance-btn-day");
    obj.performanceMonthBtn = document.querySelector(".js-performance-btn-month");
    obj.performanceHeading = document.querySelector(".js-performance-heading");
    return obj;
};
const $c1a9c97858d35935$export$ed6f46ab308363cb = function() {
    $c1a9c97858d35935$var$performanceEls = $c1a9c97858d35935$var$getElements();
};
const $c1a9c97858d35935$export$342336acfc67dcc = function(handler) {
    [
        $c1a9c97858d35935$var$performanceEls.performanceDayBtn,
        $c1a9c97858d35935$var$performanceEls.performanceMonthBtn
    ].forEach((btn)=>btn.addEventListener("click", (e)=>{
            btn.parentElement.querySelectorAll("button").forEach((b)=>b.classList.remove("btn--tertiary--active"));
            e.target.classList.add("btn--tertiary--active");
            handler(e.target.getAttribute("data-type"));
        }));
};
const $c1a9c97858d35935$var$updatePerformanceHeading = function(type) {
    $c1a9c97858d35935$var$performanceEls.performanceHeading.querySelector("span").textContent = type;
};
const $c1a9c97858d35935$export$d9f294a5242c3d6c = function() {
    $c1a9c97858d35935$var$performanceEls.performanceCanvas.innerHTML = "";
};
let $c1a9c97858d35935$var$chartData = [];
let $c1a9c97858d35935$var$chartType;
const $c1a9c97858d35935$export$92d7692aae4606e9 = function(passedData) {
    let type, data;
    if (passedData) {
        type = passedData[0];
        data = passedData[1];
        console.log(data);
        $c1a9c97858d35935$var$updatePerformanceHeading(type);
        $c1a9c97858d35935$export$d9f294a5242c3d6c();
    }
    if (data) $c1a9c97858d35935$var$chartData = [
        ...data
    ], $c1a9c97858d35935$var$chartType = type;
    else data = $c1a9c97858d35935$var$chartData, type = $c1a9c97858d35935$var$chartType;
    const canvasRect = $c1a9c97858d35935$var$performanceEls.performanceCanvas.getBoundingClientRect();
    // create room for axes
    const margin = {
        top: 25,
        right: 20,
        bottom: 50,
        left: 60
    };
    const graphWidth = canvasRect.width - margin.left - margin.right;
    const graphHeight = canvasRect.height - margin.top - margin.bottom;
    // create svg container, specify width & height, translate to create room for axes labels
    const svg = d3.select(".js-performance-canvas").append("svg").attr("class", "performance-canvas").attr("viewBox", `0 0 ${canvasRect.width} ${canvasRect.height}`);
    // create a group for our graph elements and append it to our svg
    const graph = svg.append("g").attr("width", graphWidth).attr("height", graphHeight).attr("transform", `translate(${margin.left}, ${margin.top})`);
    // create scales
    const x = d3.scaleLinear().range([
        0,
        graphWidth
    ]);
    const y = d3.scaleLinear().range([
        graphHeight,
        0
    ]);
    // create axes groups
    const xAxisGroup = graph.append("g").attr("transform", `translate(0, ${graphHeight})`).attr("class", "performance-axis-x");
    const yAxisGroup = graph.append("g").attr("class", "performance-axis-y");
    // set up d3 line graph generator
    // it will generate a line, based on our data points
    // it returns a long string that is then used for 'd' attribute of the svg path
    const line = d3.line().x(function(d) {
        return x(d.position);
    }).y(function(d) {
        return y(d.total);
    });
    // create line path element
    const path = graph.append("path");
    // ZONE - update function
    const updatePerformanceChart = function(data = $c1a9c97858d35935$var$chartData) {
        // create responsive gaps for the chart
        const maxMinVals = d3.extent(data, (d)=>d.total);
        const gap = Math.round((maxMinVals[1] - maxMinVals[0]) / 6);
        // set scale domains
        // x.domain(d3.extent(data, d => d.position)); // find the lowest and highest dates, return in array format
        x.domain([
            d3.min(data, (d)=>d.position) - 0.5,
            d3.max(data, (d)=>d.position) + 0.5
        ]);
        y.domain([
            d3.min(data, (d)=>d.total) - gap,
            d3.max(data, (d)=>d.total) + gap
        ]); // find the highest value
        // update path data
        // when we are using d3 line, we need to pass the data inside of another array
        path.data([
            data
        ]).attr("d", line).attr("class", "performance-line");
        // create circles for objects
        // join data to the selection
        const circles = graph.selectAll("circle").data(data);
        // remove unwanted points
        circles.exit().remove();
        // add new points
        circles.enter().append("circle").attr("cx", (d)=>x(d.position)).attr("cy", (d)=>{
            return y(Math.round(d.total));
        }).attr("class", "performance-circles");
        // update current points
        circles.attr("cx", (d)=>x(d.position)).attr("cy", (d)=>y(Math.round(d.total)));
        // create axes
        const xAxis = d3.axisBottom(x).ticks(data.length).tickFormat((d)=>data[d].dateShort);
        // .tickFormat(d => (data[d - 1] ? data[d - 1].dateShort : '')); // create bottom axis based on our x scale
        const yAxis = d3.axisLeft(y).ticks(4).tickFormat((d)=>(0, $ge6e3.kFormatter)(d, 999, ""));
        // generate all shapes for xAxis and yAxis and place them in axis groups
        xAxisGroup.call(xAxis);
        yAxisGroup.call(yAxis);
        // ZONE - generate horizontal lines
        const yAxisTicks = $c1a9c97858d35935$var$performanceEls.performanceCanvas.querySelectorAll("g.performance-axis-y g.tick");
        const yTicksTranslates = Array.from(yAxisTicks).map((t)=>t.getAttribute("transform"));
        const horizontalLinesGroup = graph.append("g");
        for(let i = 0; i < yTicksTranslates.length; i++){
            const horizontalLine = horizontalLinesGroup.append("line").attr("class", "performance-graph-line").attr("x1", 0).attr("x2", graphWidth).attr("y1", 0).attr("y2", 0).attr("transform", yTicksTranslates[i]);
        }
        // ZONE - create circle labels
        const points = Array.from($c1a9c97858d35935$var$performanceEls.performanceCanvas.querySelectorAll("circle.performance-circles"));
        const pointsCoords = points.map((point)=>[
                point.getAttribute("cx"),
                point.getAttribute("cy")
            ]);
        const labelsGroup = graph.append("g");
        for(let i = 0; i < pointsCoords.length; i++)labelsGroup.append("text").text((0, $ge6e3.kFormatter)(data[i].total, 9999)).attr("class", `${data[i].returnCash >= 0 ? "performance-label" : "performance-label--negative"}`).attr("transform", `translate(${pointsCoords[i][0] - 20}, ${pointsCoords[i][1] - (data[i].returnCash >= 0 ? 15 : -25)})`);
        // select x axis text and translate down every odd text to make space
        xAxisGroup.selectAll("g.tick:nth-child(odd) text").attr("transform", "translate(0, 18)").attr("class", "performance-axis-odd");
    };
    // change the buttons accordingly
    [
        $c1a9c97858d35935$var$performanceEls.performanceDayBtn,
        $c1a9c97858d35935$var$performanceEls.performanceMonthBtn
    ].forEach((btn)=>btn.classList.remove("btn--tertiary--active"));
    if (type === "Daily") $c1a9c97858d35935$var$performanceEls.performanceDayBtn.classList.add("btn--tertiary--active");
    if (type === "Monthly") $c1a9c97858d35935$var$performanceEls.performanceMonthBtn.classList.add("btn--tertiary--active");
    updatePerformanceChart(data);
};


const $503cdf3f114f357f$var$formatShortDate = function(dateShort) {
    const splitDate = dateShort.split("/");
    splitDate.shift();
    return splitDate.join("/");
};
const $503cdf3f114f357f$var$formatMonthlyData = function(calendarData, journal) {
    let monthsArr = [];
    Object.keys(calendarData).forEach((monthKey)=>{
        monthsArr.push(calendarData[monthKey].map((day)=>day.trades));
    });
    let formattedMonthsArr = [];
    monthsArr.forEach((month)=>{
        const returnCash = month.flat().map((item)=>item.returnCash).reduce((acc, num)=>acc + num, 0);
        const dateLong = month[0].dateLong;
        const dateShort = $503cdf3f114f357f$var$formatShortDate(month[0].dateShort);
        const lastDay = month[month.length - 1];
        const lastTradeIndexInJournal = journal.map((trade)=>trade.id).indexOf(lastDay[lastDay.length - 1].id);
        formattedMonthsArr.push({
            returnCash: returnCash,
            dateLong: dateLong,
            dateShort: dateShort,
            total: Math.round(journal[lastTradeIndexInJournal].total)
        });
    });
    formattedMonthsArr = formattedMonthsArr.slice(-16);
    formattedMonthsArr.sort((a, b)=>new Date(a.dateLong) - new Date(b.dateLong));
    formattedMonthsArr.forEach((month, index)=>{
        month.position = index;
    });
    return formattedMonthsArr;
};
const $503cdf3f114f357f$var$formatDailyData = function(calendarData, journal) {
    let daysArr = [];
    Object.keys(calendarData).forEach((monthKey)=>{
        daysArr.push(...calendarData[monthKey].map((day)=>{
            day.trades.dateShort = day.dateShort;
            day.trades.dateLong = day.dateLong;
            return day.trades;
        }));
    });
    let formattedDaysArr = daysArr.map((day)=>{
        const returnCash = day.map((trade)=>{
            if (trade.returnCash) return trade.returnCash;
        }).reduce((acc, num)=>acc + num, 0);
        const lastTradeIndexInJournal = journal.map((trade)=>trade.id).indexOf(day[day.length - 1].id);
        return {
            dateShort: day.dateShort,
            dateLong: day.dateLong,
            returnCash: returnCash,
            total: Math.round(journal[lastTradeIndexInJournal].total)
        };
    });
    formattedDaysArr = formattedDaysArr.slice(-16);
    formattedDaysArr.sort((a, b)=>new Date(a.dateLong) - new Date(b.dateLong));
    formattedDaysArr.forEach((day, index)=>{
        day.position = index;
    });
    return formattedDaysArr;
};
const $503cdf3f114f357f$export$8f6229a4fc51a714 = function(calendarData, capital, journal, type) {
    if (type === "day") return [
        "Daily",
        $503cdf3f114f357f$var$formatDailyData(calendarData, journal, capital)
    ];
    if (type === "month") return [
        "Monthly",
        $503cdf3f114f357f$var$formatMonthlyData(calendarData, journal, capital)
    ];
};



var $ge6e3 = parcelRequire("ge6e3");
let $249060bb6c1aa900$var$bestWorstEls = {};
const $249060bb6c1aa900$var$getElements = function(obj = {}) {
    obj.bestWorstCanvas = document.querySelector(".js-worst-best-canvas");
    obj.worstBtn = document.querySelector(".js-worst-btn");
    obj.bestBtn = document.querySelector(".js-best-btn");
    return obj;
};
const $249060bb6c1aa900$export$e54228181dd4b244 = function() {
    $249060bb6c1aa900$var$bestWorstEls = $249060bb6c1aa900$var$getElements();
};
const $249060bb6c1aa900$export$a56b97566a6c0973 = function() {
    $249060bb6c1aa900$var$bestWorstEls.bestWorstCanvas.innerHTML = "";
};
const $249060bb6c1aa900$export$117dacaeeabe4fe0 = function(handler) {
    [
        $249060bb6c1aa900$var$bestWorstEls.worstBtn,
        $249060bb6c1aa900$var$bestWorstEls.bestBtn
    ].forEach((btn)=>{
        btn.addEventListener("click", (e)=>{
            btn.parentElement.querySelectorAll("button").forEach((b)=>b.classList.remove("btn--tertiary--active"));
            e.target.classList.add("btn--tertiary--active");
            handler(e.target.getAttribute("data-type"));
        });
    });
};
// ZONE - D3
let $249060bb6c1aa900$var$chartData = [];
let $249060bb6c1aa900$var$chartType;
const $249060bb6c1aa900$export$c9a4f371c7c1da4b = function(passedData) {
    let type, data;
    if (passedData) {
        type = passedData[0];
        data = passedData[1];
        $249060bb6c1aa900$export$a56b97566a6c0973();
    }
    if (data) $249060bb6c1aa900$var$chartData = [
        ...data
    ], $249060bb6c1aa900$var$chartType = type;
    else data = $249060bb6c1aa900$var$chartData, type = $249060bb6c1aa900$var$chartType;
    const determineSign = function(data) {
        if (type === "worst") return -Math.abs(data);
        return Math.abs(data);
    };
    const canvasRect = $249060bb6c1aa900$var$bestWorstEls.bestWorstCanvas.getBoundingClientRect();
    // create room for axes
    const margin = {
        top: 25,
        right: 20,
        bottom: 50,
        left: 50
    };
    const graphWidth = canvasRect.width - margin.left - margin.right;
    const graphHeight = canvasRect.height - margin.top - margin.bottom;
    // create svg container, specify width & height, translate to create room for axes labels
    const svg = d3.select(".js-worst-best-canvas").append("svg").attr("class", "worst-best-canvas").attr("viewBox", `0 0 ${canvasRect.width} ${canvasRect.height}`);
    // create graph for the elements and append it to our svg
    const graph = svg.append("g").attr("width", graphWidth).attr("height", graphHeight).attr("transform", `translate(${margin.left}, ${margin.top})`);
    // create scales
    const y = d3.scaleLinear().range([
        graphHeight,
        0
    ]);
    const x = d3.scaleBand().range([
        0,
        graphWidth
    ]).paddingInner(0.5).paddingOuter(0.5);
    // create a group for the x and y axis
    const xAxisGroup = graph.append("g").attr("transform", `translate(0, ${graphHeight})`).attr("class", "worst-best-axis-x");
    const yAxisGroup = graph.append("g").attr("class", "worst-best-axis-y");
    // create and call the axes
    const xAxis = d3.axisBottom(x).tickFormat((d)=>{
        const index = data.map((item)=>item.id).indexOf(d);
        return data[index].ticker;
    });
    const yAxis = d3.axisLeft(y).ticks(6).tickFormat((d)=>{
        if (type === "worst") return -Math.abs((0, $ge6e3.kFormatter)(d, 9999));
        if (type === "best") return Math.abs((0, $ge6e3.kFormatter)(d, 9999));
    });
    // ZONE - update function
    const updateWorstBestChart = function(data = $249060bb6c1aa900$var$chartData) {
        // create responsive gap for the chart
        const maxMinVals = d3.extent(data, (d)=>d.returnCash);
        const gap = Math.round((maxMinVals[1] - maxMinVals[0]) / 6);
        // set scale domains
        y.domain([
            0,
            d3.max(data, (d)=>d.returnCash) + gap
        ]);
        x.domain(data.map((item)=>item.id));
        // join data to rectangles inside our graph group
        const rects = graph.selectAll("rect").data(data);
        // remove any unwanted shapes
        rects.exit().remove();
        // update already existing rectangles in DOM
        rects.attr("width", x.bandwidth).attr("y", (d)=>y(total)).attr("fill", "orange");
        // update and append virtual elements
        rects.enter().append("rect").attr("width", x.bandwidth).attr("height", 0).attr("y", graphHeight).attr("x", (d)=>x(d.id)).attr("fill", "orange").attr("height", (d)=>graphHeight - y(d.returnCash)).attr("y", (d)=>y(d.returnCash)).attr("class", "worst-best-bars");
        // apply axes to axes groups
        xAxisGroup.call(xAxis);
        yAxisGroup.call(yAxis);
        // ZONE - create bars labels
        const bars = Array.from($249060bb6c1aa900$var$bestWorstEls.bestWorstCanvas.querySelectorAll("rect.worst-best-bars"));
        const barsDimensions = bars.map((bar)=>[
                bar.getAttribute("x"),
                bar.getAttribute("y"),
                bar.getAttribute("width"),
                bar.getAttribute("height")
            ]);
        const labelsGroup = graph.append("g");
        for(let i = 0; i < barsDimensions.length; i++){
            labelsGroup.append("text").text((0, $ge6e3.kFormatter)(determineSign(data[i].returnCash), 9999)).attr("class", `${type === "best" ? "best" : "worst"}-trades-label`).attr("transform", `translate(${barsDimensions[i][0]}, ${barsDimensions[i][1] - 10})`);
            labelsGroup.append("text").text(data[i].dateShort).attr("class", "worst-best-date").attr("transform", `translate(${barsDimensions[i][0] - 8}, ${graphHeight - 10}) rotate(-90)`);
        }
        // ZONE - create horizontal line on the x axis to cover the bars borders
        const xOverlayLineGroup = graph.append("g");
        xOverlayLineGroup.append("line").attr("x1", 0).attr("x2", graphWidth).attr("y1", graphHeight).attr("y2", graphHeight).attr("class", "worst-best-overlay-line");
        // select x axis text and translate down every odd text to make space
        xAxisGroup.selectAll("g.tick:nth-child(odd) text").attr("transform", "translate(0, 18)");
        // change the buttons accordingly
        [
            $249060bb6c1aa900$var$bestWorstEls.worstBtn,
            $249060bb6c1aa900$var$bestWorstEls.bestBtn
        ].forEach((btn)=>btn.classList.remove("btn--tertiary--active"));
        if (type === "worst") $249060bb6c1aa900$var$bestWorstEls.worstBtn.classList.add("btn--tertiary--active");
        if (type === "best") $249060bb6c1aa900$var$bestWorstEls.bestBtn.classList.add("btn--tertiary--active");
    };
    updateWorstBestChart(data);
};


const $051ccacebfe308a2$export$58e31da28d35c67 = function(type, stocksData) {
    if (type === "worst") {
        const dataCopy = [];
        stocksData.forEach((stock)=>dataCopy.push({
                ...stock
            }));
        dataCopy.forEach((stock)=>stock.returnCash = Math.abs(stock.returnCash));
        return [
            "worst",
            dataCopy.slice(0, 8)
        ];
    }
    if (type === "best") return [
        "best",
        stocksData.slice(0, 8)
    ];
};


let $3722b11e83dcb8a1$var$detailsEls = {};
const $3722b11e83dcb8a1$var$getElements = function(obj = {}) {
    obj.capitalOutput = document.querySelector(".js-capital-output span");
    return obj;
};
const $3722b11e83dcb8a1$export$fa700b856caa86ae = function() {
    $3722b11e83dcb8a1$var$detailsEls = $3722b11e83dcb8a1$var$getElements();
};
const $3722b11e83dcb8a1$export$a2ee3ea4d011cf19 = function(capitalData) {
    $3722b11e83dcb8a1$var$detailsEls.capitalOutput.textContent = capitalData ? capitalData : 0;
};



var $fZ5A9 = parcelRequire("fZ5A9");
let $0c44f0bd5602ea26$var$journalEntriesEls = {};
const $0c44f0bd5602ea26$var$getElements = function(obj = {}) {
    obj.journalEntriesWrapper = document.querySelector(".js-journal-entries-wrapper");
    obj.journalPaginationWrapper = document.querySelector(".js-journal-pagination");
    obj.journalFormWrapper = document.querySelector(".js-journal-form-wrapper");
    return obj;
};
const $0c44f0bd5602ea26$export$54ecfb8f1fe9d5e0 = function() {
    $0c44f0bd5602ea26$var$journalEntriesEls = $0c44f0bd5602ea26$var$getElements();
};
const $0c44f0bd5602ea26$export$1dfc2697e726bd2a = function(handler) {
    $0c44f0bd5602ea26$var$journalEntriesEls.journalEntriesWrapper.addEventListener("click", (e)=>{
        if (e.target.closest(".c-journal-entry")) {
            const clickedCard = e.target.closest(".c-journal-entry");
            $0c44f0bd5602ea26$var$journalEntriesEls.journalEntriesWrapper.querySelector(".c-journal-entry--active").classList.remove("c-journal-entry--active");
            clickedCard.classList.add("c-journal-entry--active");
            return handler(clickedCard.getAttribute("data-id"));
        }
        return;
    });
};
const $0c44f0bd5602ea26$export$6538832e69fe36e6 = function(handler) {
    $0c44f0bd5602ea26$var$journalEntriesEls.journalPaginationWrapper.addEventListener("click", (e)=>{
        if (e.target.classList.contains("js-journal-pagination-btn")) handler(+e.target.getAttribute("data-pagination-btn"));
    });
};
const $0c44f0bd5602ea26$export$d7e83717e0c1c317 = function() {
    const emptyCard = $0c44f0bd5602ea26$var$journalEntriesEls.journalEntriesWrapper.querySelector(".c-journal-entry--new");
    if (emptyCard) {
        emptyCard.remove();
        $0c44f0bd5602ea26$var$activateEntry($0c44f0bd5602ea26$var$selectFirstEntry());
    }
};
const $0c44f0bd5602ea26$var$selectFirstEntry = function() {
    return $0c44f0bd5602ea26$var$journalEntriesEls.journalEntriesWrapper.querySelector(".c-journal-entry");
};
const $0c44f0bd5602ea26$var$activateEntry = function(entryEl) {
    if (!entryEl) return;
    const previouslyActive = $0c44f0bd5602ea26$var$journalEntriesEls.journalEntriesWrapper.querySelector(".c-journal-entry--active");
    if (previouslyActive) previouslyActive.classList.remove("c-journal-entry--active");
    entryEl.classList.add("c-journal-entry--active");
};
const $0c44f0bd5602ea26$var$makePaginationBtnActive = function(paginationPage) {
    const priorPagination = $0c44f0bd5602ea26$var$journalEntriesEls.journalEntriesWrapper.querySelector(".btn--pagination--active");
    if (priorPagination) priorPagination.classList.remove("btn--pagination--active");
    $0c44f0bd5602ea26$var$journalEntriesEls.journalEntriesWrapper.querySelectorAll(".btn--pagination")[paginationPage - 1].classList.add("btn--pagination--active");
};
const $0c44f0bd5602ea26$var$renderJournalPagination = function(entriesNumber, paginationPage) {
    $0c44f0bd5602ea26$var$journalEntriesEls.journalPaginationWrapper.innerHTML = "";
    let html = "";
    const buttonsNumber = Math.ceil(entriesNumber / (0, $fZ5A9.ENTRIES_PER_PAGE));
    for(let i = 1; i <= buttonsNumber; i++)html += `
        <button class="c-journal-pagination__button btn btn--pagination js-journal-pagination-btn" data-pagination-btn="${i}">${i}</button>
    `;
    $0c44f0bd5602ea26$var$journalEntriesEls.journalPaginationWrapper.insertAdjacentHTML("afterbegin", html);
    $0c44f0bd5602ea26$var$makePaginationBtnActive(paginationPage);
};
const $0c44f0bd5602ea26$export$6e41c491003c1ef1 = function() {
    const existingEntries = $0c44f0bd5602ea26$var$journalEntriesEls.journalEntriesWrapper.querySelectorAll(".c-journal-entry");
    if (existingEntries) existingEntries.forEach((el)=>el.remove());
    $0c44f0bd5602ea26$var$journalEntriesEls.journalPaginationWrapper.innerHTML = "";
};
const $0c44f0bd5602ea26$export$28ad05ccb59edc35 = function(entriesData, paginationPage = 1, clear = true) {
    if (entriesData.length < 1) return;
    const existingEls = $0c44f0bd5602ea26$var$journalEntriesEls.journalEntriesWrapper.querySelectorAll(".c-journal-entry");
    if (existingEls && clear) existingEls.forEach((el)=>el.remove());
    const entriesRange = paginationPage !== 1 ? [
        paginationPage * -(0, $fZ5A9.ENTRIES_PER_PAGE),
        paginationPage * -(0, $fZ5A9.ENTRIES_PER_PAGE) + (0, $fZ5A9.ENTRIES_PER_PAGE)
    ] : [
        -(0, $fZ5A9.ENTRIES_PER_PAGE)
    ];
    if (!entriesData) return;
    entriesData.slice(...entriesRange).forEach((entry)=>{
        const html = `
      <div class="c-journal-entry ${entry.id ? "" : "c-journal-entry--new"}" data-id=${entry.id}>
          <div class="c-journal-entry__unit-wrapper">
              <span class="c-journal-entry__date">${entry.dateShort}</span>
              <span class="c-journal-entry__data">${entry.ticker}</span>
          </div>
          <div class="c-journal-entry__unit-wrapper">
              <span class="c-journal-entry__data">${entry.side} side</span>
              <span class="c-journal-entry__data">${entry.sharesAmount} shares</span>
          </div>
          <div class="c-journal-entry__unit-wrapper">
              <span class="c-journal-entry__data">avg.entry: ${entry.avgEntry}</span>
              <span class="c-journal-entry__data">return: ${entry.returnCash}</span>
          </div>
          <div class="c-journal-entry__unit-wrapper">
              <span class="c-journal-entry__data">avg.exit: ${entry.avgExit}</span>
              <span class="c-journal-entry__data">% return ${entry.returnPercent}</span>
          </div>
          <svg class="c-journal-entry__chevron svg svg--chevron" viewBox="0 0 31 20"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 1.5L15.5 16.5L29.5 1.5" stroke="#AAAAAA" stroke-width="4" />
          </svg>
      </div>
      `;
        $0c44f0bd5602ea26$var$journalEntriesEls.journalEntriesWrapper.insertAdjacentHTML("afterbegin", html);
    });
    const entriesLength = clear ? entriesData.length : $0c44f0bd5602ea26$var$journalEntriesEls.journalEntriesWrapper.querySelector(".c-journal-entry").length;
    $0c44f0bd5602ea26$var$activateEntry($0c44f0bd5602ea26$var$selectFirstEntry());
    if (clear) $0c44f0bd5602ea26$var$renderJournalPagination(entriesLength, paginationPage);
    return +$0c44f0bd5602ea26$var$selectFirstEntry().getAttribute("data-id");
};


let $e9bdc97313b2bde9$var$journalFilterEls = {};
const $e9bdc97313b2bde9$var$getElements = function(obj = {}) {
    obj.journalFiltersWrapper = document.querySelector(".js-journal-filter");
    obj.journalEntriesWrapper = document.querySelector(".js-journal-entries-wrapper");
    return obj;
};
const $e9bdc97313b2bde9$export$ade2f8ebdf671755 = function() {
    $e9bdc97313b2bde9$var$journalFilterEls = $e9bdc97313b2bde9$var$getElements();
};
const $e9bdc97313b2bde9$export$b5471ef757f23da7 = function(handler) {
    $e9bdc97313b2bde9$var$journalFilterEls.journalFiltersWrapper.addEventListener("click", (e)=>{
        const existingNewEntry = $e9bdc97313b2bde9$var$journalFilterEls.journalEntriesWrapper.querySelector(".c-journal-entry--new");
        if (e.target.classList.contains("js-new-trade-btn") && !existingNewEntry) handler("new");
        if (e.target.classList.contains("js-filter-btn") && !existingNewEntry) handler("filter");
    });
};




var $ge6e3 = parcelRequire("ge6e3");
let $c28d5dce26dc9c00$var$journalFormEls = {};
const $c28d5dce26dc9c00$var$getElements = function(obj = {}) {
    obj.journalFormWrapper = document.querySelector(".js-journal-form-wrapper");
    obj.journalEntriesWrapper = document.querySelector(".js-journal-entries-wrapper");
    obj.detailsEntryPriceAvg;
    obj.detailsExitPriceAvg;
    obj.detailsEntrySharesTotal;
    obj.detailsExitSharesTotal;
    return obj;
};
const $c28d5dce26dc9c00$var$toggleDisabledState = function(mode) {
    $c28d5dce26dc9c00$var$journalFormEls.manualInputs.forEach((input)=>{
        input.disabled = mode;
    });
};
const $c28d5dce26dc9c00$var$recalculateDetailsPrice = function(targetElClass, siblingElClass) {
    const inputsArr = Array.from($c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelectorAll(targetElClass));
    const weightedResultsArr = inputsArr.map((input)=>+input.value * (input.nextElementSibling.value ? +input.nextElementSibling.value : 1));
    const allShares = Array.from($c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelectorAll(siblingElClass)).map((input)=>input.value ? +input.value : 1).reduce((acc, num)=>acc + num, 0);
    const filteredWeightedResultsArr = weightedResultsArr.filter((num)=>num !== 0);
    return (filteredWeightedResultsArr.reduce((acc, num)=>acc + num, 0) / allShares).toFixed(2);
};
const $c28d5dce26dc9c00$var$recalculateDetailsShares = function(targetElClass) {
    return Array.from($c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelectorAll(targetElClass)).map((input)=>+input.value).reduce((acc, num)=>acc + num, 0);
};
const $c28d5dce26dc9c00$var$calculateDetailsOutput = function(focusedEl) {
    $c28d5dce26dc9c00$var$journalFormEls.detailsEntryPriceAvg.textContent = $c28d5dce26dc9c00$var$recalculateDetailsPrice(".c-journal-form__entry", ".c-journal-form__entry-size");
    $c28d5dce26dc9c00$var$journalFormEls.detailsEntrySharesTotal.textContent = $c28d5dce26dc9c00$var$recalculateDetailsShares(".c-journal-form__entry-size");
    $c28d5dce26dc9c00$var$journalFormEls.detailsExitPriceAvg.textContent = $c28d5dce26dc9c00$var$recalculateDetailsPrice(".c-journal-form__exit", ".c-journal-form__exit-size");
    $c28d5dce26dc9c00$var$journalFormEls.detailsExitSharesTotal.textContent = $c28d5dce26dc9c00$var$recalculateDetailsShares(".c-journal-form__exit-size");
};
const $c28d5dce26dc9c00$var$addKeyEventToDetailsInputs = function() {
    let keystrokeTimer;
    $c28d5dce26dc9c00$var$journalFormEls.journalForm.querySelectorAll(".js-form-details-input").forEach((input)=>{
        input.addEventListener("keyup", (e)=>{
            clearTimeout(keystrokeTimer);
            keystrokeTimer = setTimeout(()=>{
                $c28d5dce26dc9c00$var$calculateDetailsOutput(e.target);
            }, 1000);
        });
    });
};
const $c28d5dce26dc9c00$var$removeFirstCrossInstances = function() {
    $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelector(".c-journal-form__entry-size-wrapper .js-form-remove-details-row-btn").classList.add("c-journal-form__entry-size-remove-wrapper--disabled");
    $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelector(".c-journal-form__exit-size-wrapper .js-form-remove-details-row-btn").classList.add("c-journal-form__exit-size-remove-wrapper--disabled");
};
const $c28d5dce26dc9c00$var$addCrossIconToExtraRows = function(targetEl) {
    const crossBtn = targetEl.previousElementSibling.lastElementChild.lastElementChild;
    if (crossBtn.classList.contains("c-journal-form__entry-size-remove-wrapper--disabled")) crossBtn.classList.remove("c-journal-form__entry-size-remove-wrapper--disabled");
    if (crossBtn.classList.contains("c-journal-form__exit-size-remove-wrapper--disabled")) crossBtn.classList.remove("c-journal-form__exit-size-remove-wrapper--disabled");
};
const $c28d5dce26dc9c00$export$1ff3a74b750b2389 = function() {
    $c28d5dce26dc9c00$var$journalFormEls = $c28d5dce26dc9c00$var$getElements();
};
const $c28d5dce26dc9c00$export$cc034749ec8fbb73 = function(handler) {
    $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.addEventListener("click", (e)=>{
        if (e.target.classList.contains("js-form-edit-btn") && $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.classList.contains("s-journal__form-wrapper--read-mode")) handler("edit");
        if (e.target.classList.contains("js-form-cancel-btn")) {
            const formId = $c28d5dce26dc9c00$var$journalFormEls.journalForm.getAttribute("data-id");
            if (formId) handler("cancel", formId);
            else handler("cancel", $c28d5dce26dc9c00$var$journalFormEls.journalEntriesWrapper.querySelector(".c-journal-entry").nextElementSibling.getAttribute("data-id"));
        }
        if (e.target.classList.contains("js-form-swap-btn")) handler("swap");
        if (e.target.classList.contains("js-form-plus-btn")) handler("extra", "", e.target);
        if (e.target.classList.contains("js-form-remove-details-row-btn")) handler("pop", "", e.target);
        if (e.target.classList.contains("js-form-save-btn")) handler("save");
        if (e.target.classList.contains("js-form-delete-btn")) handler("delete");
    });
};
const $c28d5dce26dc9c00$export$cd0931d5f4b2d609 = function() {
    return $c28d5dce26dc9c00$var$journalFormEls.journalForm.getAttribute("data-id");
};
const $c28d5dce26dc9c00$export$de11385a3c3ed77b = function(el) {
    el.parentElement.remove();
    el.remove();
    $c28d5dce26dc9c00$var$journalFormEls.detailsEntrySharesTotal.textContent = $c28d5dce26dc9c00$var$recalculateDetailsShares(".c-journal-form__entry-size");
    $c28d5dce26dc9c00$var$journalFormEls.detailsExitSharesTotal.textContent = $c28d5dce26dc9c00$var$recalculateDetailsShares(".c-journal-form__exit-size");
    $c28d5dce26dc9c00$var$journalFormEls.detailsEntryPriceAvg.textContent = $c28d5dce26dc9c00$var$recalculateDetailsPrice(".c-journal-form__entry", ".c-journal-form__entry-size");
    $c28d5dce26dc9c00$var$journalFormEls.detailsExitPriceAvg.textContent = $c28d5dce26dc9c00$var$recalculateDetailsPrice(".c-journal-form__exit", ".c-journal-form__exit-size");
};
const $c28d5dce26dc9c00$export$13de31d01f6ea04e = function(instruction = "") {
    if (instruction === "read-only") {
        $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.classList.remove("s-journal__form-wrapper--edit-mode");
        $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.classList.add("s-journal__form-wrapper--read-mode");
        return;
    }
    if ($c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.classList.contains("s-journal__form-wrapper--read-mode")) {
        $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.classList.remove("s-journal__form-wrapper--read-mode");
        $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.classList.add("s-journal__form-wrapper--edit-mode");
        $c28d5dce26dc9c00$var$journalFormEls.manualInputs.forEach((input)=>{
            input.disabled = false;
        });
    } else if ($c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.classList.contains("s-journal__form-wrapper--edit-mode")) {
        $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.classList.remove("s-journal__form-wrapper--edit-mode");
        $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.classList.add("s-journal__form-wrapper--read-mode");
        $c28d5dce26dc9c00$var$toggleDisabledState(true);
    }
};
const $c28d5dce26dc9c00$export$55c5452cdf1cc8a0 = function(targetEl) {
    const lastRow = targetEl.previousElementSibling.lastElementChild;
    const rowClone = lastRow.cloneNode(true);
    lastRow.insertAdjacentElement("afterend", rowClone);
    $c28d5dce26dc9c00$var$addKeyEventToDetailsInputs();
    $c28d5dce26dc9c00$var$addCrossIconToExtraRows(targetEl);
    $c28d5dce26dc9c00$var$journalFormEls.detailsEntrySharesTotal.textContent = $c28d5dce26dc9c00$var$recalculateDetailsShares(".c-journal-form__entry-size");
    $c28d5dce26dc9c00$var$journalFormEls.detailsExitSharesTotal.textContent = $c28d5dce26dc9c00$var$recalculateDetailsShares(".c-journal-form__exit-size");
    $c28d5dce26dc9c00$var$journalFormEls.detailsEntryPriceAvg.textContent = $c28d5dce26dc9c00$var$recalculateDetailsPrice(".c-journal-form__entry", ".c-journal-form__entry-size");
    $c28d5dce26dc9c00$var$journalFormEls.detailsExitPriceAvg.textContent = $c28d5dce26dc9c00$var$recalculateDetailsPrice(".c-journal-form__exit", ".c-journal-form__exit-size");
};
const $c28d5dce26dc9c00$export$904435e4dbb8296e = function() {
    if ($c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.classList.contains("s-journal__form-wrapper--read-mode")) $c28d5dce26dc9c00$export$13de31d01f6ea04e();
};
const $c28d5dce26dc9c00$export$96f130ad451fefde = function() {
    const sideValueEl = $c28d5dce26dc9c00$var$journalFormEls.swapBtn.previousElementSibling.firstElementChild;
    sideValueEl.value === "long" ? sideValueEl.value = "short" : sideValueEl.value = "long";
};
const $c28d5dce26dc9c00$export$dae8b145e7aa20b3 = function() {
    const formInputs = {
        id: $c28d5dce26dc9c00$var$journalFormEls.journalForm.getAttribute("data-id"),
        date: $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelector(".js-form-date-input").value,
        stock: $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelector(".js-form-stock-input").value,
        side: $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelector(".js-form-stock-side").value,
        entriesPrices: Array.from($c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelectorAll(".js-form-entry-input")).map((el)=>el.value),
        entriesShares: Array.from($c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelectorAll(".js-form-entry-shares-input")).map((el)=>el.value),
        exitsPrices: Array.from($c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelectorAll(".js-form-exit-input")).map((el)=>el.value),
        exitsShares: Array.from($c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelectorAll(".js-form-exit-shares-input")).map((el)=>el.value),
        body: $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelector(".js-form-body-input").value
    };
    return formInputs;
};
const $c28d5dce26dc9c00$export$c5dec251f728614b = function() {
    $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.innerHTML = "";
};
const $c28d5dce26dc9c00$export$73574a7ebb05d01e = function(message = "fail") {
    $c28d5dce26dc9c00$var$journalFormEls.formValidationError.textContent = message;
};
const $c28d5dce26dc9c00$export$6b94a84f48c15f96 = function() {
    $c28d5dce26dc9c00$var$journalFormEls.formValidationError.textContent = "";
};
const $c28d5dce26dc9c00$export$2c43c8cb2e9930d5 = function(singleEntry) {
    $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.innerHTML = "";
    [singleEntry] = singleEntry;
    const html = `
    <div class="c-journal-form js-journal-form" data-id="${singleEntry.id}">
      <div class="c-journal-form__upper-region">
          <div class="c-journal-form__unit-wrapper">
              <span class="c-journal-form__data">date: <input
                      class="c-input-text c-input-text--compact c-journal-form__manual-input js-form-date-input"
                       value="${singleEntry.dateShort ? singleEntry.dateShort : (0, $ge6e3.createShortDate)()}" disabled>
              </span>
              <span class="c-journal-form__data">stock: <input
                      class="c-input-text c-input-text--compact c-journal-form__manual-input js-form-stock-input"
                      type="text" value="${singleEntry.ticker}" disabled></span>
          </div>
          <div class="c-journal-form__unit-wrapper">
              <div class="c-journal-form__trade-side-wrapper">
                  <span class="c-journal-form__data">side: <input
                          class="c-input-text c-input-text--compact c-journal-form__side-input js-form-stock-side"
                          type="text" value="${singleEntry.side ? singleEntry.side : "long"}" disabled></span>
                  <button class="c-journal-form__swap btn btn--form-icon c-journal-form__edit-mode-btn js-form-swap-btn">
                      <svg class="svg svg--swap" viewBox="0 0 17 29"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.5 0L15.8612 12.75L1.13878 12.75L8.5 0Z"
                              fill="#C4C4C4" />
                          <path d="M8.5 29L1.13879 16.25L15.8612 16.25L8.5 29Z"
                              fill="#C4C4C4" />
                      </svg>
  
                  </button>
              </div>
              <span class="c-journal-form__data">%return: <input
                      class="c-input-text c-input-text--compact" type="number"
                      value="${singleEntry.returnPercent}" disabled></span>
          </div>
          <div class="c-journal-form__unit-wrapper">
              <span class="c-journal-form__data">shares: <input
                      class="c-input-text c-input-text--compact" type="number"
                      value="${singleEntry.sharesAmount}" disabled></span>
              <span class="c-journal-form__data">return: <input
                      class="c-input-text c-input-text--compact" type="number"
                      value="${singleEntry.returnCash}" disabled></span>
          </div>
      </div>
      <div class="c-journal-form__middle-region">
          <div class="c-journal-form__entries-wrapper">
              <div class="c-journal-form__entries-labels-wrapper">
                  <span class="c-journal-form__entries-label">entries</span>
                  <span class="c-journal-form__entries-label">shares</span>
              </div>
              <div class="c-journal-form__entries-inner-wrapper js-entries-wrapper">
                  
              </div>
              <button class="c-journal-form__plus-entry btn btn--icon c-journal-form__edit-mode-btn js-form-plus-btn">
                  <svg class="svg svg--plus-circle" viewBox="0 0 17 17"
                      xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8.5" cy="8.5" r="8.5" fill="#29242A" />
                      <path d="M14 7H3V10H14V7Z" fill="#C4C4C4" />
                      <path d="M10 14V3H7L7 14H10Z" fill="#C4C4C4" />
                  </svg>
  
              </button>
              <div class="c-journal-form__entries-labels-wrapper">
                  <span class="c-journal-form__entries-label">average: <br><span
                          class="c-journal-form__entries-label-result js-details-entry-price-average">${singleEntry.tradeEntries[0][0] ? (singleEntry.tradeEntries.map((single)=>single[0] * single[1]).reduce((acc, num)=>acc + num, 0) / singleEntry.tradeEntries.map((single)=>single[1]).reduce((acc, num)=>acc + num, 0)).toFixed(2) : ""}</span></span>
                  <span class="c-journal-form__average-entry">shares: <br><span
                          class="c-journal-form__entries-label-result js-details-entry-shares-result">${singleEntry.tradeExits[0][1] ? singleEntry.tradeExits.map((single)=>single[1]).reduce((acc, num)=>acc + num, 0) : ""}</span></span>
              </div>
          </div>
          <div class="c-journal-form__exits-wrapper">
              <div class="c-journal-form__exits-labels-wrapper">
                  <span class="c-journal-form__exits-label">exits</span>
                  <span class="c-journal-form__exits-label">shares</span>
              </div>
              <div class="c-journal-form__exits-inner-wrapper js-exits-wrapper">
                
              </div>
              <button class="c-journal-form__plus-exit btn btn--icon c-journal-form__edit-mode-btn js-form-plus-btn">
                  <svg class="svg svg--plus-circle" viewBox="0 0 17 17"
                      xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8.5" cy="8.5" r="8.5" fill="#29242A" />
                      <path d="M14 7H3V10H14V7Z" fill="#C4C4C4" />
                      <path d="M10 14V3H7L7 14H10Z" fill="#C4C4C4" />
                  </svg>
  
              </button>
              <div class="c-journal-form__exits-labels-wrapper">
                  <span class="c-journal-form__exits-label">average: <br><span
                          class="c-journal-form__exits-label-result js-details-exit-price-average">${singleEntry.tradeExits[0][0] ? (singleEntry.tradeExits.map((single)=>single[0] * single[1]).reduce((acc, num)=>acc + num, 0) / singleEntry.tradeExits.map((single)=>single[1]).reduce((acc, num)=>acc + num, 0)).toFixed(2) : ""}</span></span>
                  <span class="c-journal-form__average-exit">shares: <br><span
                          class="c-journal-form__exits-label-result js-details-exit-shares-result">${singleEntry.tradeExits[0][1] ? singleEntry.tradeExits.map((single)=>single[1]).reduce((acc, num)=>acc + num, 0) : ""}</span></span>
              </div>
          </div>
  
      </div>
      <p class="c-journal-form__error-message js-form-error-message"></p>
    <textarea class="c-journal-form__text-area c-journal-form__manual-input js-form-body-input" rows="10" disabled>${singleEntry.body}</textarea>
    </div>
    <div class="c-journal-form__buttons-wrapper">
        <button class="c-journal-from__button-delete btn btn--secondary js-form-delete-btn">delete</button>
        <div class="c-journal-form__buttons-inner-wrapper">
            <button class="c-journal-form__button-cancel btn btn--secondary c-journal-form__edit-mode-btn js-form-cancel-btn">cancel</button>
            <button class="c-journal-form__button-save btn btn--primary c-journal-form__edit-mode-btn js-form-save-btn">save</button>
        </div>
        <button class="c-journal-form__button-edit btn btn--primary js-form-edit-btn">edit</button>
    </div>
    `;
    $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.insertAdjacentHTML("afterbegin", html);
    $c28d5dce26dc9c00$var$journalFormEls.journalForm = document.querySelector(".js-journal-form");
    $c28d5dce26dc9c00$var$journalFormEls.formValidationError = document.querySelector(".js-form-error-message");
    const entriesSection = document.querySelector(".js-entries-wrapper");
    const exitsSection = document.querySelector(".js-exits-wrapper");
    singleEntry.tradeEntries.forEach((transaction)=>{
        entriesSection.innerHTML += `
          <div class="c-journal-form__entry-size-wrapper">
              <input type="number"
              class="c-journal-form__entry c-input-text c-input-text--compact c-journal-form__manual-input  js-form-details-input js-form-entry-input"
              value="${transaction[0]}" disabled>
              <input type="number"
              class="c-journal-form__entry-size c-input-text c-input-text--compact c-journal-form__manual-input  js-form-details-input js-form-entry-shares-input"
              value="${transaction[1]}" disabled>
              <div class="c-journal-form__entry-size-remove-wrapper c-journal-form__edit-mode-btn js-form-remove-details-row-btn">
                <span class="c-journal-form__entry-size-remove-btn">x</span>
              </div>
          </div>
        `;
    });
    singleEntry.tradeExits.forEach((transaction)=>{
        exitsSection.innerHTML += `
          <div class="c-journal-form__exit-size-wrapper">
              <input type="number"
              class="c-journal-form__exit c-input-text c-input-text--compact c-journal-form__manual-input js-form-details-input js-form-exit-input"
              value="${transaction[0]}" disabled>
              <input type="number"
              class="c-journal-form__exit-size c-input-text c-input-text--compact c-journal-form__manual-input  js-form-details-input js-form-exit-shares-input"
              value="${transaction[1]}" disabled>
              <div class="c-journal-form__exit-size-remove-wrapper c-journal-form__edit-mode-btn js-form-remove-details-row-btn">
              <span class="c-journal-form__exit-size-remove-btn">x</span>
            </div>
          </div>
        `;
    });
    $c28d5dce26dc9c00$var$journalFormEls.swapBtn = $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelector(".js-form-swap-btn");
    $c28d5dce26dc9c00$var$journalFormEls.manualInputs = $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelectorAll(".c-journal-form__manual-input");
    $c28d5dce26dc9c00$var$journalFormEls.detailsExitPriceAvg = $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelector(".js-details-exit-price-average");
    $c28d5dce26dc9c00$var$journalFormEls.detailsExitSharesTotal = $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelector(".js-details-exit-shares-result");
    $c28d5dce26dc9c00$var$journalFormEls.detailsEntryPriceAvg = $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelector(".js-details-entry-price-average");
    $c28d5dce26dc9c00$var$journalFormEls.detailsEntrySharesTotal = $c28d5dce26dc9c00$var$journalFormEls.journalFormWrapper.querySelector(".js-details-entry-shares-result");
    $c28d5dce26dc9c00$var$addKeyEventToDetailsInputs();
    $c28d5dce26dc9c00$var$removeFirstCrossInstances();
};



var $ge6e3 = parcelRequire("ge6e3");
const $7cdf33b3600ed002$export$e038565b582e5220 = function(inputData, accountCapital = 0) {
    if (accountCapital < 1) return [
        "ERROR",
        "Account capital needs to be above zero"
    ];
    const dateLong = (0, $ge6e3.createLongDate)(inputData.date);
    // dates validation
    let dateRegex = /^[0-9\/]+$/;
    if (dateLong === "ERROR") return [
        "ERROR",
        "date must be in the format of dd/mm/yy"
    ];
    const dateShort = (0, $ge6e3.createShortDate)(dateLong);
    // stock ticker validation
    let tickerRegex = /^[a-zA-Z]+$/;
    let ticker;
    if (!tickerRegex.test(inputData.stock)) return [
        "ERROR",
        "Stock ticker field only accepts letters"
    ];
    ticker = inputData.stock.toUpperCase();
    // trade side
    const side = inputData.side;
    // id
    const id = inputData.id ? +inputData.id : Date.now();
    // validating trade details
    if (!inputData.entriesPrices || !inputData.entriesShares || !inputData.exitsPrices || !inputData.exitsShares) return [
        "ERROR",
        "All entries, exits and shares rows must be filled in or deleted"
    ];
    const entriesPrices = inputData.entriesPrices.map((entry)=>+entry).filter((entry)=>entry > 0);
    const entriesShares = inputData.entriesShares.map((entry)=>+entry).filter((entry)=>entry > 0);
    const exitsPrices = inputData.exitsPrices.map((exit)=>+exit).filter((entry)=>entry > 0);
    const exitsShares = inputData.exitsShares.map((exit)=>+exit).filter((entry)=>entry > 0);
    // validating if prices and shares only have digits and dots
    let entriesRegex = /^\d+(\.\d+)*$/;
    let areEntriesValid = true;
    [
        ...entriesPrices,
        ...entriesShares,
        ...exitsPrices,
        ...exitsShares
    ].forEach((digit)=>{
        if (!entriesRegex.test(digit)) areEntriesValid = false;
    });
    if (!areEntriesValid) return [
        "ERROR",
        "All entries, exits and shares must be positive and only contain digits and dots"
    ];
    if (entriesPrices.length !== entriesShares.length || exitsPrices.length !== exitsShares.length) return [
        "ERROR",
        "All entries, exits and shares rows must be filled in or deleted. Only positive digits and dots are accepted"
    ];
    // check if the number of entry shares equals the number of exit shares
    const sharesAmount = entriesShares.reduce((acc, num)=>acc + num, 0);
    if (sharesAmount !== exitsShares.reduce((acc, num)=>acc + num, 0)) return [
        "ERROR",
        "Entry shares must be equal to exit shares"
    ];
    // make one array for tradeEntries and one for tradeExits to match the format
    let tradeEntries = [];
    entriesPrices.forEach((price, index)=>{
        tradeEntries.push([
            price,
            entriesShares[index]
        ]);
    });
    let tradeExits = [];
    exitsPrices.forEach((price, index)=>{
        tradeExits.push([
            price,
            exitsShares[index]
        ]);
    });
    // calculate avg entry price
    const avgEntry = +(tradeEntries.map((row)=>row[0] * row[1]).reduce((acc, num)=>acc + num, 0) / sharesAmount).toFixed(2);
    // calculate avg exit price
    const avgExit = +(tradeExits.map((row)=>row[0] * row[1]).reduce((acc, num)=>acc + num, 0) / sharesAmount).toFixed(2);
    // calculate cash return
    let returnCash;
    if (side === "long") returnCash = +((avgExit - avgEntry) * sharesAmount).toFixed(2);
    if (side === "short") returnCash = +((avgEntry - avgExit) * sharesAmount).toFixed(2);
    // calculate account % return
    const returnPercent = +(returnCash / accountCapital * 100).toFixed(2);
    const body = inputData.body;
    const entryObj = {
        id: id,
        dateLong: dateLong,
        dateShort: dateShort,
        ticker: ticker,
        side: side,
        tradeEntries: tradeEntries,
        tradeExits: tradeExits,
        sharesAmount: sharesAmount,
        avgEntry: avgEntry,
        avgExit: avgExit,
        returnCash: returnCash,
        returnPercent: returnPercent,
        body: body,
        previousTicker: "",
        previousDateShort: "",
        previousDateLong: ""
    };
    // all validation checks passed
    return [
        "PASS",
        entryObj
    ];
};


let $4c22adf96f0377b2$var$settingsEls = {};
const $4c22adf96f0377b2$var$getElements = function(obj = {}) {
    obj.settingsResetBtn = document.querySelector(".js-settings-reset-btn");
    return obj;
};
const $4c22adf96f0377b2$export$1ace71b954a791e2 = function() {
    $4c22adf96f0377b2$var$settingsEls = $4c22adf96f0377b2$var$getElements();
};
const $4c22adf96f0377b2$export$275ab183d4140f60 = function(handler) {
    $4c22adf96f0377b2$var$settingsEls.settingsResetBtn.addEventListener("click", handler);
};


// ZONE - controllers
const $f50bd1f2915ed0f2$var$controlLoading = function() {
    (0, $31bd2817d4b028c5$export$86eb99e836e70b77)();
};
const $f50bd1f2915ed0f2$var$controlNoDataScreens = function() {
    const outcome = (0, $b33589c348b8bea3$export$b126a3dab554319)();
    if (outcome === "empty") (0, $31bd2817d4b028c5$export$ca94f9cd30199838)();
    if (outcome === "full") (0, $31bd2817d4b028c5$export$d3874125acfa916)();
};
const $f50bd1f2915ed0f2$var$controlNavigation = function(targetEl) {
    const furtherAction = (0, $31bd2817d4b028c5$export$65d711c204a27870)(targetEl);
    if (furtherAction === "rerender") {
        (0, $c1a9c97858d35935$export$d9f294a5242c3d6c)();
        (0, $249060bb6c1aa900$export$a56b97566a6c0973)();
        (0, $507dc9d3b582608c$export$74f677f40ed95de)();
        (0, $c1a9c97858d35935$export$92d7692aae4606e9)();
        (0, $249060bb6c1aa900$export$c9a4f371c7c1da4b)();
        (0, $507dc9d3b582608c$export$17cae48d2b736b73)();
    }
};
const $f50bd1f2915ed0f2$var$mobileMenuTrigger = function() {};
const $f50bd1f2915ed0f2$var$controlPopups = function(action, dataAttr, entryID) {
    if (action === "hide") (0, $31bd2817d4b028c5$export$bba5038aab73375b)();
    if (action === "proceed") {
        if (dataAttr === "logoff") (0, $31bd2817d4b028c5$export$2fb87bbf5418dbe1)();
        if (dataAttr === "reset") {
            (0, $b33589c348b8bea3$export$a50b7e3211510c43)();
            $f50bd1f2915ed0f2$var$controlNoDataScreens();
            $f50bd1f2915ed0f2$var$controlProfitableRender();
            $f50bd1f2915ed0f2$var$controlOverallRender();
            $f50bd1f2915ed0f2$var$controlPerformanceRender();
            $f50bd1f2915ed0f2$var$controlWorstBestRender();
            $f50bd1f2915ed0f2$var$controlMonthlyRender();
            $f50bd1f2915ed0f2$var$controlLongShortPieRender();
            $f50bd1f2915ed0f2$var$controlJournalRender();
            (0, $3722b11e83dcb8a1$export$a2ee3ea4d011cf19)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("capital"));
            (0, $31bd2817d4b028c5$export$bba5038aab73375b)();
            (0, $31bd2817d4b028c5$export$d478bd899ecaa824)("You can do so in the capital management section", "Your account capital is now 0 and needs to be updated", "Application has been reset");
        }
        if (dataAttr === "delete") {
            (0, $31bd2817d4b028c5$export$bba5038aab73375b)();
            (0, $b33589c348b8bea3$export$539b580c1d8ce0cb)(+entryID);
            $f50bd1f2915ed0f2$var$controlNoDataScreens();
            $f50bd1f2915ed0f2$var$controlProfitableRender();
            $f50bd1f2915ed0f2$var$controlOverallRender();
            $f50bd1f2915ed0f2$var$controlPerformanceRender();
            $f50bd1f2915ed0f2$var$controlWorstBestRender();
            $f50bd1f2915ed0f2$var$controlMonthlyRender();
            $f50bd1f2915ed0f2$var$controlLongShortPieRender();
            $f50bd1f2915ed0f2$var$controlJournalRender();
            (0, $31bd2817d4b028c5$export$d478bd899ecaa824)("Entry has been deleted");
            (0, $b33589c348b8bea3$export$d40bb6bd8ada8865)();
            (0, $3722b11e83dcb8a1$export$a2ee3ea4d011cf19)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("capital"));
        }
    }
};
const $f50bd1f2915ed0f2$var$controlCalcCapital = function(amount, action) {
    const capitalData = (0, $b33589c348b8bea3$export$d40bb6bd8ada8865)(amount, action);
    (0, $5c945194c19474d5$export$2f2fc3119d24f888)(capitalData);
    (0, $3722b11e83dcb8a1$export$a2ee3ea4d011cf19)(capitalData[2]);
};
const $f50bd1f2915ed0f2$var$controlCalcPosition = function(data) {
    if (!data) return (0, $5c945194c19474d5$export$b67e165217167740)("positionResult");
    const positionResult = (0, $03827f1b7c3185bc$export$44b0c40bdeb407b0)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("capital"), data);
    if (isNaN(positionResult)) return;
    (0, $5c945194c19474d5$export$3c09fca5a796c0a3)(positionResult, "positionResult");
};
const $f50bd1f2915ed0f2$var$controlCalcRatio = function(data) {
    if (!data) return (0, $5c945194c19474d5$export$b67e165217167740)("ratioResult");
    const ratioResult = (0, $03827f1b7c3185bc$export$c23150291e680048)(data);
    if (isNaN(ratioResult) || !ratioResult) return (0, $5c945194c19474d5$export$b67e165217167740)("ratioResult");
    (0, $5c945194c19474d5$export$3c09fca5a796c0a3)(ratioResult, "ratioResult");
};
const $f50bd1f2915ed0f2$var$controlMonthlyRender = function() {
    const computedData = (0, $595a7b13736253d0$export$8254cbabffce0112)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("calendarData"));
    // renderMonthlyTable(updateCalendarData(computedData));
    (0, $53cfc6b9034ec443$export$4b9e39c5b0ba6c40)(computedData);
};
const $f50bd1f2915ed0f2$var$controlProfitableRender = function() {
    const profitableStocks = (0, $911163ba9bcb34be$export$693324c8bf5b90cb)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("tickers"));
    (0, $bc029bfc0551362a$export$28abb260122841e0)(profitableStocks);
};
const $f50bd1f2915ed0f2$var$controlOverallRender = function() {
    (0, $507dc9d3b582608c$export$ff290589fa1cea4c)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("overall"));
    (0, $507dc9d3b582608c$export$d43dd3db639c38)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("streaks"));
};
const $f50bd1f2915ed0f2$var$controlPerformanceRender = function(type = "day") {
    (0, $c1a9c97858d35935$export$92d7692aae4606e9)((0, $503cdf3f114f357f$export$8f6229a4fc51a714)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("calendarData"), (0, $b33589c348b8bea3$export$b60d557ba3977c66)("capital"), (0, $b33589c348b8bea3$export$b60d557ba3977c66)("journal"), type));
};
const $f50bd1f2915ed0f2$var$controlWorstBestRender = function(type = "worst") {
    if (type === "worst") (0, $249060bb6c1aa900$export$c9a4f371c7c1da4b)((0, $051ccacebfe308a2$export$58e31da28d35c67)(type, (0, $b33589c348b8bea3$export$b60d557ba3977c66)("worstTrades")));
    if (type === "best") (0, $249060bb6c1aa900$export$c9a4f371c7c1da4b)((0, $051ccacebfe308a2$export$58e31da28d35c67)(type, (0, $b33589c348b8bea3$export$b60d557ba3977c66)("bestTrades")));
};
const $f50bd1f2915ed0f2$var$controlLongShortPieRender = function() {
    (0, $507dc9d3b582608c$export$17cae48d2b736b73)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("overall").proportions);
};
const $f50bd1f2915ed0f2$var$controlJournalRender = function() {
    const activeEntryID = (0, $0c44f0bd5602ea26$export$28ad05ccb59edc35)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("journal"));
    if (!activeEntryID) {
        (0, $0c44f0bd5602ea26$export$6e41c491003c1ef1)();
        (0, $c28d5dce26dc9c00$export$c5dec251f728614b)();
        return;
    }
    (0, $c28d5dce26dc9c00$export$2c43c8cb2e9930d5)((0, $b33589c348b8bea3$export$925ab5cb31bc2750)(activeEntryID));
};
const $f50bd1f2915ed0f2$var$controlJournalFormEvents = function(action, id = "", targetEl = "") {
    if (action === "edit") {
        (0, $c28d5dce26dc9c00$export$6b94a84f48c15f96)();
        (0, $c28d5dce26dc9c00$export$13de31d01f6ea04e)();
    }
    if (action === "cancel") {
        (0, $0c44f0bd5602ea26$export$d7e83717e0c1c317)();
        (0, $c28d5dce26dc9c00$export$13de31d01f6ea04e)();
        (0, $c28d5dce26dc9c00$export$2c43c8cb2e9930d5)((0, $b33589c348b8bea3$export$925ab5cb31bc2750)(+id));
    }
    if (action === "swap") (0, $c28d5dce26dc9c00$export$96f130ad451fefde)();
    if (action === "extra") (0, $c28d5dce26dc9c00$export$55c5452cdf1cc8a0)(targetEl);
    if (action === "pop") (0, $c28d5dce26dc9c00$export$de11385a3c3ed77b)(targetEl);
    if (action === "delete") {
        const currentEntryID = (0, $c28d5dce26dc9c00$export$cd0931d5f4b2d609)();
        if (currentEntryID) (0, $31bd2817d4b028c5$export$aff20287cfa3135e)(currentEntryID, "delete", "Are you sure you want to delete this existing entry?");
        else (0, $31bd2817d4b028c5$export$aff20287cfa3135e)("", "delete", "Are you sure you want to delete this new entry?");
    }
    if (action === "save") {
        (0, $c28d5dce26dc9c00$export$6b94a84f48c15f96)();
        const validationOutcome = (0, $7cdf33b3600ed002$export$e038565b582e5220)((0, $c28d5dce26dc9c00$export$dae8b145e7aa20b3)(), (0, $b33589c348b8bea3$export$b60d557ba3977c66)("capital"));
        if (validationOutcome[0] === "ERROR") (0, $c28d5dce26dc9c00$export$73574a7ebb05d01e)(validationOutcome[1]);
        if (validationOutcome[0] === "PASS") {
            (0, $c28d5dce26dc9c00$export$6b94a84f48c15f96)();
            const updatedCapital = (0, $b33589c348b8bea3$export$420fe83f4630f7b6)(validationOutcome[1]);
            (0, $31bd2817d4b028c5$export$d478bd899ecaa824)(`% return: ${validationOutcome[1].returnPercent}, cash return: ${validationOutcome[1].returnCash}`, `stock: ${validationOutcome[1].ticker}, date: ${validationOutcome[1].dateShort}`, "Journal has been updated and sorted");
            (0, $c28d5dce26dc9c00$export$13de31d01f6ea04e)("read-only");
            $f50bd1f2915ed0f2$var$controlJournalRender();
            (0, $3722b11e83dcb8a1$export$a2ee3ea4d011cf19)(updatedCapital);
            // re-render visualisations
            $f50bd1f2915ed0f2$var$controlNoDataScreens();
            $f50bd1f2915ed0f2$var$controlOverallRender();
            $f50bd1f2915ed0f2$var$controlLongShortPieRender();
            $f50bd1f2915ed0f2$var$controlWorstBestRender("best");
            $f50bd1f2915ed0f2$var$controlWorstBestRender();
            $f50bd1f2915ed0f2$var$controlProfitableRender();
            $f50bd1f2915ed0f2$var$controlPerformanceRender();
            $f50bd1f2915ed0f2$var$controlMonthlyRender();
            (0, $b33589c348b8bea3$export$1b8cd2d0ef9a8e5d)();
        }
    }
};
const $f50bd1f2915ed0f2$var$controlJournalActiveEntries = function(id = "") {
    if (!id) return;
    (0, $0c44f0bd5602ea26$export$d7e83717e0c1c317)();
    (0, $c28d5dce26dc9c00$export$13de31d01f6ea04e)("read-only");
    (0, $c28d5dce26dc9c00$export$2c43c8cb2e9930d5)((0, $b33589c348b8bea3$export$925ab5cb31bc2750)(+id));
};
const $f50bd1f2915ed0f2$var$controlJournalFilters = function(action, id = "") {
    if (action === "new") {
        if ((0, $b33589c348b8bea3$export$b60d557ba3977c66)("capital") < 1) {
            (0, $31bd2817d4b028c5$export$d478bd899ecaa824)("You can do so in the capital management section", "Please add more capital to your account", "Your account capital has fallen below 0");
            return;
        }
        (0, $c28d5dce26dc9c00$export$13de31d01f6ea04e)("read-only");
        (0, $0c44f0bd5602ea26$export$28ad05ccb59edc35)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("dummyJournal"), "", false);
        (0, $c28d5dce26dc9c00$export$2c43c8cb2e9930d5)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("dummyJournal"));
        (0, $c28d5dce26dc9c00$export$904435e4dbb8296e)();
    }
    if (action === "filter") (0, $31bd2817d4b028c5$export$d478bd899ecaa824)("Unfortunately the filters feature is not available in the current version");
};
const $f50bd1f2915ed0f2$var$controlJournalPagination = function(paginationBtn) {
    const activeEntryID = (0, $0c44f0bd5602ea26$export$28ad05ccb59edc35)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("journal"), paginationBtn);
    (0, $c28d5dce26dc9c00$export$13de31d01f6ea04e)("read-only");
    (0, $c28d5dce26dc9c00$export$2c43c8cb2e9930d5)((0, $b33589c348b8bea3$export$925ab5cb31bc2750)(activeEntryID));
};
const $f50bd1f2915ed0f2$var$controlAppReset = function() {
    (0, $31bd2817d4b028c5$export$aff20287cfa3135e)("", "reset", "All user data will be deleted", "Are you sure you want to reset the application?");
};
const $f50bd1f2915ed0f2$var$queryDOM = function() {
    (0, $31bd2817d4b028c5$export$ac96e30d6d6c1be4)();
    (0, $bc029bfc0551362a$export$b6be05e0cf54d5d3)();
    (0, $507dc9d3b582608c$export$d9660c11a41b6e8e)();
    (0, $c1a9c97858d35935$export$ed6f46ab308363cb)();
    (0, $3722b11e83dcb8a1$export$fa700b856caa86ae)();
    (0, $249060bb6c1aa900$export$e54228181dd4b244)();
    (0, $53cfc6b9034ec443$export$7ace4912664725f5)();
    (0, $0c44f0bd5602ea26$export$54ecfb8f1fe9d5e0)();
    (0, $e9bdc97313b2bde9$export$ade2f8ebdf671755)();
    (0, $c28d5dce26dc9c00$export$1ff3a74b750b2389)();
    (0, $5c945194c19474d5$export$6e4d76765bcebd1b)();
    (0, $4c22adf96f0377b2$export$1ace71b954a791e2)();
};
// ZONE - event listeners
window.addEventListener("DOMContentLoaded", (e)=>{
    (0, $b33589c348b8bea3$export$3197e788f26697e3)();
    $f50bd1f2915ed0f2$var$queryDOM();
    $f50bd1f2915ed0f2$var$controlNoDataScreens();
    (0, $31bd2817d4b028c5$export$9c0b5467ca05928c)($f50bd1f2915ed0f2$var$controlNavigation);
    (0, $31bd2817d4b028c5$export$5c73b62e7604c855)((0, $31bd2817d4b028c5$export$e322dd3310a00bc9));
    (0, $3722b11e83dcb8a1$export$a2ee3ea4d011cf19)((0, $b33589c348b8bea3$export$b60d557ba3977c66)("capital"));
    (0, $5c945194c19474d5$export$ae25a6d41d7c5d04)($f50bd1f2915ed0f2$var$controlCalcPosition);
    (0, $5c945194c19474d5$export$ae96ffaca1b313ed)($f50bd1f2915ed0f2$var$controlCalcRatio);
    (0, $5c945194c19474d5$export$6067ee6b47f9a18f)($f50bd1f2915ed0f2$var$controlCalcCapital);
    (0, $c1a9c97858d35935$export$342336acfc67dcc)($f50bd1f2915ed0f2$var$controlPerformanceRender);
    (0, $249060bb6c1aa900$export$117dacaeeabe4fe0)($f50bd1f2915ed0f2$var$controlWorstBestRender);
    (0, $e9bdc97313b2bde9$export$b5471ef757f23da7)($f50bd1f2915ed0f2$var$controlJournalFilters);
    (0, $0c44f0bd5602ea26$export$1dfc2697e726bd2a)($f50bd1f2915ed0f2$var$controlJournalActiveEntries);
    (0, $c28d5dce26dc9c00$export$cc034749ec8fbb73)($f50bd1f2915ed0f2$var$controlJournalFormEvents);
    (0, $0c44f0bd5602ea26$export$6538832e69fe36e6)($f50bd1f2915ed0f2$var$controlJournalPagination);
    (0, $31bd2817d4b028c5$export$83b746114fb11012)($f50bd1f2915ed0f2$var$controlPopups);
    (0, $4c22adf96f0377b2$export$275ab183d4140f60)($f50bd1f2915ed0f2$var$controlAppReset);
    setTimeout(()=>{
        $f50bd1f2915ed0f2$var$controlLoading();
        $f50bd1f2915ed0f2$var$controlProfitableRender();
        $f50bd1f2915ed0f2$var$controlOverallRender();
        $f50bd1f2915ed0f2$var$controlPerformanceRender();
        $f50bd1f2915ed0f2$var$controlWorstBestRender();
        $f50bd1f2915ed0f2$var$controlMonthlyRender();
        $f50bd1f2915ed0f2$var$controlLongShortPieRender();
        $f50bd1f2915ed0f2$var$controlJournalRender();
    }, 700);
});
let $f50bd1f2915ed0f2$var$resizeTimer;
window.addEventListener("resize", (e)=>{
    clearTimeout($f50bd1f2915ed0f2$var$resizeTimer);
    $f50bd1f2915ed0f2$var$resizeTimer = setTimeout(()=>{
        (0, $c1a9c97858d35935$export$d9f294a5242c3d6c)();
        (0, $249060bb6c1aa900$export$a56b97566a6c0973)();
        (0, $507dc9d3b582608c$export$74f677f40ed95de)();
        (0, $c1a9c97858d35935$export$92d7692aae4606e9)();
        (0, $249060bb6c1aa900$export$c9a4f371c7c1da4b)();
        (0, $507dc9d3b582608c$export$17cae48d2b736b73)();
    }, 1000);
});


//# sourceMappingURL=app.c57a5dc5.js.map
